<template>
    <div>









        <CRow>
            <CCol md="9">







                <CButton
                        @click="collapseFilter = !collapseFilter"
                        color="info"
                        class="mb-2"
                >
                    فیلتر
                </CButton>

                <CButton
                        @click="collapseNewIssue = !collapseNewIssue"
                        color="primary"
                        class="mb-2"
                >
                    Issue جدید
                </CButton>



                <CButton
                        @click="getIssuesByType('user-story')"
                        color="dark"
                        class="mb-2"
                        varient="outline"
                >
                    پست / لیست
                </CButton>
                <CButton
                        @click="getIssuesByType('lead')"
                        color="dark"
                        class="mb-2"
                        varient="outline"
                >
                    {{$sale}}
                </CButton>
                <CButton
                         @click="getIssuesByType('meeting')"
                        color="dark"
                        class="mb-2"
                        varient="outline"
                >
                    مذاکره
                </CButton>
                <CButton
                        @click="getIssuesByType('ticket')"
                        color="dark"
                        class="mb-2"
                        varient="outline"
                >
                    پیگیری (پشتیانی، تلفن و...)
                </CButton>
                <CButton
                        @click="getIssuesByType('task')"
                        color="dark"
                        class="mb-2"
                        varient="outline"
                >
                    فعالیت
                </CButton>




                    <CCollapse :show="collapseFilter">
                        <CCard class="center-div p-5">

                            <div
                                    style="cursor: pointer"  >
                                <div class="text-right margin-10 d-flex">
                                    <!--                                        tagSearc
                                                    var url = '/home/file/fileSearch/?input='+app.tagSearch
                                    h-->

                                    <div class="row text-right ">

                                        <div class="col-3 my-2">
                                            <small> از تاریخ ثبت:</small>
                                            <custom-time-picker
                                                    v-model="search.created_at_from" @change="getIssues()"
                                                    type="date" :clearable="true" placeholder="" min="" max=""
                                                    size="sm" input-class="form-control form-control-sm">
                                            </custom-time-picker>
                                        </div>

                                        <div class="col-3 my-2">
                                            <small> تا تاریخ ثبت:</small>
                                            <custom-time-picker
                                                    v-model="search.created_at_to" @change="getIssues()"
                                                    type="date" :clearable="true" placeholder="" min="" max=""
                                                    size="sm" input-class="form-control form-control-sm">
                                            </custom-time-picker>
                                        </div>


                                        <div class="col-3 my-2">
                                            <small> از تاریخ انجام:</small>
                                            <custom-time-picker
                                                    v-model="search.done_date_from" @change="getIssues()"
                                                    type="date" :clearable="true" placeholder="" min="" max=""
                                                    size="sm" input-class="form-control form-control-sm">
                                            </custom-time-picker>
                                        </div>

                                        <div class="col-3 my-2">
                                            <small> تا تاریخ انجام:</small>
                                            <custom-time-picker
                                                    v-model="search.done_date_to" @change="getIssues()"
                                                    type="date" :clearable="true" placeholder="" min="" max=""
                                                    size="sm" input-class="form-control form-control-sm">
                                            </custom-time-picker>
                                        </div>


                                        <!--                                  <div class="col-12">-->
                                        <!--                                      <label> برچسب:</label>-->

                                        <!--&lt;!&ndash;                                      <b-form-input&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                              v-model="tagSearch"&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                              type="text"&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                              @keyup="getIssues()"&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                              size="sm"&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                              placeholder="برچسب (تگ)"&ndash;&gt;-->
                                        <!--&lt;!&ndash;                                      ></b-form-input>&ndash;&gt;-->

                                        <!--                                  </div>-->




                                        <div class="col-4 my-2">
                                            <small> موضوع:</small>
                                            <b-form-input v-model="search.title"
                                                          @keyup="getIssues()"
                                                          size="sm"
                                                          type="text"
                                                          placeholder="">
                                            </b-form-input>
                                        </div>




                                        <div class="col-4 my-2">
                                            <small>  نوع:</small>
                                            <b-form-select  size="sm" style="direction: ltr"
                                                            @change="getIssues()"
                                                            v-model="search.type"
                                                            type="text">
                                                <b-form-select-option  value="">همه</b-form-select-option>
                                                <b-form-select-option  value="lead" style="color: #f50057">سرنخ/فرصت (Lead)</b-form-select-option>
                                                <b-form-select-option  value="meeting" style="color: #8e24aa">ملاقات/جلسه/رویداد</b-form-select-option>
                                                <b-form-select-option  value="ticket" style="color: #263238" >پیگیری (Ticket)</b-form-select-option>
                                                <b-form-select-option  value="bug" style="color: #dd2c00">ایراد (Bug)</b-form-select-option>
                                                <b-form-select-option  value="task" style="color: #00c853">فعالیت (Task)</b-form-select-option>
                                                <b-form-select-option  value="user-story" style="color: #0097a7">لیست (User Story)</b-form-select-option>
                                                <b-form-select-option  value="epic" style="color: #0288d1">نسخه/فیچر (Epic)</b-form-select-option>
                                                <b-form-select-option  value="etc" style="color: #888888">سایر</b-form-select-option>
                                            </b-form-select>
                                        </div>



                                        <div class="col-4 my-2">
                                            <small>  وضعیت انجام:</small>
                                            <b-form-select  size="sm" style="direction: ltr"
                                                            @change="getIssues()"
                                                            v-model="search.board_id"
                                                            type="text">
                                                <b-form-select-option  value="">همه</b-form-select-option>
                                                <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                                <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                                <b-form-select-option  value="3"  style="color: #aeb130">درحال انجام (Doing)</b-form-select-option>
                                                <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>
                                                <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>
                                            </b-form-select>
                                        </div>

                                        <div class="col-4 my-2">
                                            <small>  اولویت:</small>
                                            <b-form-select  size="sm" style="direction: ltr"
                                                            @change="getIssues()"
                                                            v-model="search.priority"
                                                            type="text">
                                                <b-form-select-option  value="">همه</b-form-select-option>
                                                <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                                <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                                <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>
                                            </b-form-select>
                                        </div>


                                        <div class="col-4 my-2">
                                            <small> فرایند:</small>
                                            <b-form-select  size="sm" style="direction: ltr"
                                                            v-model="search.process_id" @change="getIssues()"
                                            >
                                                <!--                                          getSteps($event) &&-->
                                                <b-form-select-option  value="">
                                                    همه
                                                </b-form-select-option>
                                                <b-form-select-option  v-for="(process, processIndex) in processes" :key="processIndex"
                                                                       :value="process.id"  >
                                                    {{process.title}}
                                                </b-form-select-option>

                                            </b-form-select>
                                        </div>

                                        <div class="col-4 my-2">
                                            <small> مرحله:</small>
                                            <b-form-select  size="sm" style="direction: ltr"
                                                            v-model="search.step_id" @change="getIssues()"
                                            >
                                                <b-form-select-option  value="">
                                                    همه
                                                </b-form-select-option>
                                                <b-form-select-option  v-for="(step, stepIndex) in steps" :key="stepIndex"   :value="step.id" >
                                                    {{step.title}}
                                                </b-form-select-option>



                                            </b-form-select>
                                        </div>



                                        <!--                                <div class="col-12 my-2">-->
                                        <!--                                    <small> مشتری:</small>-->
                                        <!--                                    <b-form-select  size="sm" style="direction: ltr"-->
                                        <!--                                                    v-model="search.contact_id" @change="getIssues()"-->
                                        <!--                                    >-->
                                        <!--                                        <b-form-select-option  value="">-->
                                        <!--                                            همه-->
                                        <!--                                        </b-form-select-option>-->

                                        <!--                                        <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"   :value="contact.id" >-->
                                        <!--                                            {{contact.last_name}}-->
                                        <!--                                        </b-form-select-option>-->


                                        <!--                                    </b-form-select>-->
                                        <!--                                </div>-->

                                        <!--                                  <div class="col-12 my-2">-->
                                        <!--                                      <small> پروژه:</small>-->
                                        <!--                                      <b-form-select  size="sm" style="direction: ltr"-->
                                        <!--                                      >-->
                                        <!--                                          <b-form-select-option  value="">-->
                                        <!--                                              همه-->
                                        <!--                                          </b-form-select-option>-->


                                        <!--                                      </b-form-select>-->
                                        <!--                                  </div>-->
                                        <!--                                <div class="col-4 mt-3">-->
                                        <!--                                    <button @click="getIssues()" class="btn btn-success">فیلتر</button>-->
                                        <!--                                </div>-->


                                    </div>




                                    <!--                                  <multiselect  v-model="newPost.fileLib_tags" :height="300" :options="options" :multiple="true"-->
                                    <!--                                                                  :taggable="true" :close-on-select="false" :clear-on-select="false"-->
                                    <!--                                                                  :custom-label="customLabel"-->
                                    <!--                                                                  :preserve-search="true" :hide-selected="true" :show-labels="false"-->
                                    <!--                                                                  tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"-->
                                    <!--                                                                  label="title" track-by="title" :preselect-first="false"-->

                                    <!--                                                                  @tag="addTag">-->
                                    <!--                                                        &lt;!&ndash; <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single"-->
                                    <!--                                        v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template> &ndash;&gt;-->
                                    <!--                                        </multiselect>-->
                                </div>
                            </div>

                        </CCard>
                    </CCollapse>












                <CCollapse :show="collapseNewIssue">

                <CCard class="center-div">




                    <b-row class="mt-2">




                        <b-col md="12" class="">

                            <b-col md="12" class="bg-white ml-1" style="border-bottom: 4px solid #eee">
                                <div>
                                    <div>

                                        <b-input
                                                v-model="newIssue.title" class="my-1 mt-2"
                                                placeholder="عنوان" rows="2"
                                                :rules="rules"
                                        ></b-input>
                                        <b-textarea v-if="newIssue.title"
                                                    v-model="newIssue.intro" id="textarea-rows" class="my-1 mt-2"
                                                    placeholder="توضیحات ..." rows="2"
                                                    :rules="rules"
                                        ></b-textarea>


                                        <b-row  v-if="newIssue.title">

                                            <b-col  md="5">
                                                <b-form-select v-model="newIssue.type"  size="sm" class="mt-2" style="direction: ltr">

                                                    <b-form-select-option  value="lead" style="color: #f50057">سرنخ/فرصت (Lead)</b-form-select-option>
                                                    <b-form-select-option  value="meeting" style="color: #8e24aa">ملاقات/جلسه/رویداد</b-form-select-option>
                                                    <b-form-select-option  value="ticket" style="color: #263238" >پیگیری (Ticket)</b-form-select-option>
                                                    <b-form-select-option  value="bug" style="color: #dd2c00">ایراد (Bug)</b-form-select-option>
                                                    <b-form-select-option  value="task" style="color: #00c853">فعالیت (Task)</b-form-select-option>
                                                    <b-form-select-option  value="user-story" style="color: #0097a7">لیست (User Story)</b-form-select-option>
                                                    <b-form-select-option  value="epic" style="color: #0288d1">نسخه/فیچر (Epic)</b-form-select-option>
                                                    <b-form-select-option  value="etc" style="color: #888888">سایر</b-form-select-option>


                                                </b-form-select>
                                            </b-col>

                                            <b-col  md="4">
                                                <b-form-select
                                                        v-c-tooltip="{
        content: '<strong>وضعیت</strong>',
        placement: 'left'
      }"
                                                        v-model="newIssue.board_id"  size="sm" class="mt-2"  style="direction: ltr">

                                                    <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                                    <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                                    <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                                    <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>
                                                    <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>




                                                </b-form-select>
                                            </b-col>

                                            <b-col  md="3">
                                                <b-form-select title="وضعیت" v-model="newIssue.priority"  size="sm" class="mt-2"  style="direction: ltr">

                                                    <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                                    <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                                    <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>



                                                </b-form-select>
                                            </b-col>



                                            <!--                                                  <b-col  md="5" class="mt-3 mb-2">-->
                                            <!--                                                      &lt;!&ndash;                                                          <b-form-select v-model="newIssue.type"  size="sm" class="mt-2"  style="direction: ltr">&ndash;&gt;-->
                                            <!--                                                      &lt;!&ndash;                                                              <b-form-select-option  value="null" >پروژه نامشخص</b-form-select-option>&ndash;&gt;-->
                                            <!--                                                      &lt;!&ndash;                                                          </b-form-select>&ndash;&gt;-->

                                            <!--                                                      <multiselect v-model="newIssue.project_id"  @select="setForumId($event)"  :options="options"-->
                                            <!--                                                                   placeholder=" انتخاب پروژه" label="title" track-by="title">-->
                                            <!--                                                      </multiselect>-->
                                            <!--                                                  </b-col>-->


                                            <b-col  md="5" class="mt-3 mb-2">

                                                <b-form-select v-model="newIssue.contact_id"  size="sm" class="mt-2"  style="direction: ltr">
                                                    <b-form-select-option  v-for="(contact, contactIndex) in contacts" :key="contactIndex"  :value="contact.id" >{{contact.last_name}}</b-form-select-option>
                                                </b-form-select>

                                                <!--                            <multiselect  v-model="contact_id"  @select="setContactId()"    :options="contactOptions" :custom-label="customLabel"-->
                                                <!--                                         placeholder=" انتخاب مشتری" label="title" track-by="title">-->
                                                <!--                            </multiselect>-->
                                            </b-col>


                                            <b-col  md="7" class="mt-3 mb-2">
                                                <multiselect   v-model="newIssue.users" :height="300" :options="options" :multiple="true"
                                                               :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                               :custom-label="customLabel"
                                                               :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                               tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                                               label="title" track-by="title" :preselect-first="false"

                                                               @tag="addTag">

                                                </multiselect>
                                            </b-col>

                                        </b-row>

                                    </div>


                                    <div class="row my-2">
                                        <div class="col-6 " style="display: flex;justify-content: right">
                                            <b-button @click="createIssue()" variant="primary btn-sm px-1 mt-0"
                                            >ثبت پست (Issue) </b-button>
                                        </div>

                                        <b-row   v-if="newIssue.title" class="ul-upload mt-1 mb-0 col-6  text-left" style="color: #666">
                                            <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVoiceRecorder = !showVoiceRecorder"><i class="fas fa-microphone"></i></b-col>
                                            <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showImageUploader = !showImageUploader"><i class="fas fa-image"></i></b-col>
                                            <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showVideoUploader = !showVideoUploader"><i class="fas fa-film"></i></b-col>
                                            <b-col class="li-upload mr-1 mt-2 c-pointer"  @click="showFileUploader = !showFileUploader"><i class="fas fa-paperclip"></i></b-col>
                                            <b-col class="li-upload mr-2"  >
                                                <b-button v-b-toggle.collapse-1  size="sm">
                                                    <i class="fas fa-bars" aria-hidden="true"></i>
                                                </b-button>
                                            </b-col>
                                        </b-row>

                                        <div v-if="showVoiceRecorder" class="d-flex justify-content-center w-100 px-2 my-1">
                                            <!--                                                <audio-recorder-->
                                            <!--                                                        v-model="newIssue.voice"-->
                                            <!--                                                        :attempts="1"-->
                                            <!--                                                        :time="2"-->
                                            <!--                                                        :show-upload-button="false"-->
                                            <!--                                                        :before-recording="callback"-->
                                            <!--                                                        :pause-recording="callback"-->
                                            <!--                                                        :after-recording="callback"-->
                                            <!--                                                        :select-record="callback"-->
                                            <!--                                                        :before-upload="callback"-->
                                            <!--                                                        :successful-upload="callback"-->
                                            <!--                                                        :failed-upload="callback"/>-->

                                            <vue-record-audio  v-model="newIssue.voice" @result="onResult"  />

                                            <audio  :src="srcPlay"  controls class="w-100 mr-2 mt-1">
                                            </audio>

                                        </div>





                                        <div v-if="showFileUploader" class="d-flex justify-content-center w-100 px-5 my-1" >

                                            <div class="ar">
                                                <label>فایل را انتخاب کنید</label>

                                                <b-form-file v-model="newIssue.file" placeholder="فایل را انتخاب کنید" drop-placeholder="Drop file here..."
                                                             plain>
                                                </b-form-file>
                                                <!--                                                          <div class="text-center my-2" v-if="newIssue.file">-->
                                                <!--                                                              <b-form-checkbox v-model="newIssue.fileLib"  :disabled="IssueAsForum" name="check-button" switch class="d-inline" ></b-form-checkbox>-->
                                                <!--                                                              <span  class="mr-1"  style="color: #e65100">انتشار فایل در کتابخانه</span>-->
                                                <!--                                                          </div>-->
                                            </div>

                                        </div>




                                        <div v-if="showImageUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                            <div class="ar " >
                                                <label>تصویر را انتخاب کنید</label>
                                                <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                                <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                                <b-form-file v-model="newIssue.image" placeholder="تصویر را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                                </b-form-file>

                                                <!--                                                    <input type="file" class="" ref="file" @change="onFileChangeImage($event)"-->
                                                <!--                                                           placeholder="تصویر را انتخاب کنید"/>-->


                                            </div>

                                        </div>



                                        <div v-if="showVideoUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                            <div class="ar" >
                                                <label>ویدئو را انتخاب کنید</label>
                                                <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                                <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                                <b-form-file  v-model="newIssue.video" placeholder="ویدئو را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                                </b-form-file>
                                            </div>

                                        </div>





                                    </div>



                                    <div>

                                        <b-collapse id="collapse-1" class="mt-2 text-right">
                                            <b-card>
                                                <!--                                                          <b-form-select v-model="selected" :options="typeOptions" size="sm" class="mt-3"></b-form-select>-->



                                                <b-row  v-if="newIssue.title">

                                                    <b-col  md="7">

                                                        <custom-time-picker  v-model="newIssue.due_date"
                                                                             type="datetime" :clearable="true" placeholder="زمان انجام" min="" max="">
                                                        </custom-time-picker>
                                                    </b-col>

                                                    <b-col  md="5" >

                                                        <b-input
                                                                v-model="newIssue.estimated_time"
                                                                placeholder="مدت تخمینی (دقیقه)"
                                                                type="number"
                                                        ></b-input>
                                                    </b-col>



                                                    <b-col  md="12" class="mt-2">

                                                        <multiselect  v-model="newIssue.tags" :height="300" :options="options" :multiple="true"
                                                                      :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                                      :custom-label="customLabel"
                                                                      :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                                      tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"
                                                                      label="title" track-by="title" :preselect-first="false"

                                                                      @tag="addTag">
                                                        </multiselect>
                                                    </b-col>
                                                </b-row>






                                            </b-card>
                                        </b-collapse>
                                    </div>



                                </div>
                            </b-col>
                        </b-col>






                    </b-row>


                </CCard>
                </CCollapse>



                <CCard>




                    <b-row class="">


                        <b-col md="12">
                            <b-row class="">




                                <b-col md="12">




                                    <table id="testTable" class="table  table-hover">
                                        <!--                                      <thead>-->
                                        <!--                                      <tr>-->
                                        <!--                                          <th >ثبت-->
                                        <!--                                              &lt;!&ndash;                                        {{ $t('Time booking') }}&ndash;&gt;-->
                                        <!--                                          </th>-->



                                        <!--                                          &lt;!&ndash;<th>{{ $t('Score') }} </th>&ndash;&gt;-->
                                        <!--                                          <th> </th>-->
                                        <!--                                          <th> </th>-->
                                        <!--                                          &lt;!&ndash;<th>{{ $t('SMS,E-mail') }}</th>&ndash;&gt;-->

                                        <!--                                          <th width="100">&nbsp;</th>-->
                                        <!--                                      </tr>-->
                                        <!--                                      </thead>-->

                                        <tbody  v-for="(issue, issueIndex) in issues" :key="issueIndex">
                                        <tr data-toggle="collapse" :data-target="'#collapse-'+issue.id" aria-expanded="false" :aria-controls="'#collapse-'+issue.id"
                                            style="border-top: 2px solid #9e9e9e;" :style="{borderTop: headerStyles(issue)}">

                                            <!--                                      <td>-->

                                            <!--                                          <button class="btn  btn-outline-info btn-sm pt-1" type="button" >-->
                                            <!--                                              <i class="fa fa-eye"></i>-->
                                            <!--                                          </button>-->

                                            <!--                                      </td>-->

                                            <td>
                                                <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"
                                                          :style="{backgroundColor: boardColor(issue.board.id)}">
                                                    {{issue.board.title}}
                                                </b-badge>

                                            </td>


                                            <td>
                                                <h6 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h6>



                                            </td>
                                            <td>
                                            <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >
<!--                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>-->
                                                    <b-badge  v-if="step.id === issue.step_id" variant="primary">{{step.title}}</b-badge>
                                                <!--                                                    <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>-->
                                                </span>


                                            </td>

                                            <td>
                                                <small class="text-color-blue text-left " style="float: left">

                                                    <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">سرنخ/فرصت (Lead)</span>
                                                    <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ملاقات/جلسه/رویداد</span>
                                                    <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">پیگیری (Ticket)</span>
                                                    <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">ایراد (Bug)</span>
                                                    <span v-if="issue.type == 'task'" class="badge badge-success pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">فعالیت (Task)</span>
                                                    <span v-if="issue.type == 'epic'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">نسخه/فیچر (Epic)</span>
                                                    <span v-if="issue.type == 'user-story'" class="badge badge-info pt-1" :style="{backgroundColor: typeBadgeStyles(issue)}">لیست (User Story)</span>


                                                </small>


                                            </td>

                                            <td>
                                                <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>
                                                <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>
                                                <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>






                                            </td>


                                            <td class="text-left text-sm">
                                                <small>
                                                    {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>
                                                </small>


                                            </td>


                                            <!--                                    <td class="text-left text-sm">-->
                                            <!--                                            &lt;!&ndash;                                                  <div class="user-image" v-if="issue.public_user.public_profile">&ndash;&gt;-->
                                            <!--                                            &lt;!&ndash;                                                      <img v-if="issue.public_user.public_profile.image"&ndash;&gt;-->
                                            <!--                                            &lt;!&ndash;                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;&ndash;&gt;-->
                                            <!--                                            &lt;!&ndash;                                                  </div>&ndash;&gt;-->
                                            <!--                                            <router-link :to="{path : 'profile/'+issue.public_user.id }" >-->
                                            <!--                                            <span class="float-right">-->
                                            <!--                                                <span>-->
                                            <!--                                                  {{issue.public_user.name}}-->
                                            <!--                                                </span>-->
                                            <!--                                                &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>-->
                                            <!--                                            </span>-->
                                            <!--                                            </router-link>-->


                                            <!--                                      </td>-->



                                        </tr>
                                        <tr>
                                            <td colspan="6" class="collapse" :id="'collapse-'+issue.id"  style="background-color: #f6f6f6; color: #333">
                                                <div class="" style="background-color: #f6f6f6">
                                                    <b-col md="12" class=" pt-2"   style="background-color: #f6f6f6">


                                                        <b-row>

                                                            <b-col  md="12">
                                            <span  v-for="(step, stepIndex) in steps" :key="stepIndex" >
                                                     <i v-if="stepIndex != 0" class="fa fa-arrow-left"></i>
                                                    <b-badge  v-if="step.id === issue.step_id" variant="primary">{{step.title}}</b-badge>
                                                      <b-badge v-else variant="secondary" style="opacity: 30%!important;">{{step.title}}</b-badge>
                                                </span>
                                                                <hr>


                                                            </b-col>


                                                            <b-col md="4" class="text-sm ">

                                                                <!--                                                  <div class="user-image" v-if="issue.public_user.public_profile">--><!--                                                      <img v-if="issue.public_user.public_profile.image"--><!--                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;--><!--                                                  </div>-->
                                                                <router-link :to="{path : 'profile/'+issue.public_user.id }" >
                                                                    <small class="float-right"> ایجاد شده توسط:
                                                                        <span>
                                                     {{issue.public_user.name}}
                                                 </span>
                                                                        &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>
                                                                    </small>
                                                                </router-link>

                                                            </b-col>

                                                            <b-col md="8" class="text-left text-sm">
                                                                <a>
                                                                    <small class="float-right"> کاربران تخصیص داده شده:
                                                                        <span>

                                                 </span>
                                                                    </small>
                                                                </a>
                                                            </b-col>


                                                            <!--                                      <b-col  md="2">-->
                                                            <!--                                          <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"-->
                                                            <!--                                                    :style="{backgroundColor: boardColor(issue.board.id)}">-->
                                                            <!--                                              {{issue.board.title}}-->
                                                            <!--                                          </b-badge>-->

                                                            <!--                                      </b-col>-->



                                                            <!--                                      <b-col  md="2">-->
                                                            <!--                                          <small class="text-color-blue text-left " style="float: left">-->

                                                            <!--                                              <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1">سرنخ/فرصت (Lead)</span>-->
                                                            <!--                                              <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1">ملاقات/جلسه/رویداد</span>-->
                                                            <!--                                              <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1">پیگیری (Ticket)</span>-->
                                                            <!--                                              <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1">ایراد (Bug)</span>-->
                                                            <!--                                              <span v-if="issue.type == 'task'" class="badge badge-success pt-1">فعالیت (Task)</span>-->
                                                            <!--                                              <span v-if="issue.type == 'epic'" class="badge badge-info pt-1">نسخه/فیچر (Epic)</span>-->
                                                            <!--                                              <span v-if="issue.type == 'user-story'" class="badge badge-info pt-1">لیست (User Story)</span>-->


                                                            <!--                                          </small>-->


                                                            <!--                                      </b-col>-->

                                                            <!--                                      <b-col  md="2">-->
                                                            <!--                                          <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>-->
                                                            <!--                                          <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>-->
                                                            <!--                                          <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>-->






                                                            <!--                                      </b-col>-->


                                                            <!--                                      <b-col  md="4" class="text-left text-sm">-->
                                                            <!--                                          <small>-->
                                                            <!--                                              {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>-->
                                                            <!--                                          </small>-->


                                                            <!--                                      </b-col>-->




                                                        </b-row>

                                                        <div>
                                                            <hr>
                                                        </div>
                                                        <div v-if="issue.attaches" class="text-right">

                                                            <b-carousel id="carousel-1" class="h-100 mb-3" :interval="80000"
                                                                        no-wrap indicators  background="#eeeeee"
                                                                        style="text-shadow: 1px 1px 2px #333;">

                                                                <b-carousel-slide v-for="(issueFile, fileIndex) in issue.attaches" :key="fileIndex"
                                                                >
                                                                    <template v-slot:img>
                                                                        <div v-if="issueFile.type == 'image'" class="text-center " style="max-height: 300px;overflow: hidden">
                                                                            <img :title="issueFile.note"
                                                                                 :src="'/'+issueFile.file" :alt="issue.title" class="w-100">
                                                                        </div>


                                                                        <audio  v-if="issueFile.type == 'voice'" :src="'/'+issueFile.file"
                                                                                controls class="w-100 my-4">
                                                                        </audio>

                                                                        <video  v-if="issueFile.type == 'video'" class="w-100" controls>
                                                                            <source :src="'/'+issueFile.file" type="video/mp4">
                                                                            <source :src="'/'+issueFile.file" type="video/ogg">
                                                                            Your browser does not support HTML5 video.
                                                                        </video>

                                                                        <div  v-if="issueFile.type == 'file'" class="text-center my-5">
                                                                            <a target="_blank" class="btn btn-info btn-sm " v-if="issueFile.type == 'file'" :href="'/'+issueFile.file" >
                                                                                دانلود پیوست
                                                                            </a>
                                                                        </div>


                                                                    </template>
                                                                </b-carousel-slide>

                                                            </b-carousel>

                                                        </div>


                                                        <h3 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h3>
                                                        <!--                                        <pre style="font-family:IRANSans , sans-serif !important " v-html="issue.intro"></pre>-->
                                                        <p  v-html="issue.description.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="overflow: hidden; direction: rtl!important;text-align: right!important;"></p>
                                                        <small v-if="issue.text && issue.text != 'null' && issue.text != '0'" v-on:click="showIssueText(issue.text, issueIndex)" style="color: darkgrey;cursor: pointer">نمایش ادامه...</small>





                                                        <div>
                                                            <b-row class="mb-2">
                                                                <b-col  md="6" class="text-right">


                                                                    <!--                                                      <span v-on:click="likeIssue(issue)" >-->
                                                                    <!--&lt;!&ndash;                                                          <i :id="'like-fas-'+issue.id"  v-if="issue.user_like.length" class="fas fa-heart mx-10 "></i>&ndash;&gt;-->
                                                                    <!--                                                          <i :id="'like-far-'+issue.id"  class="far fa-heart mx-10"></i>-->
                                                                    <!--                                                      </span>-->

                                                                    <span v-on:click="issue.comment = !issue.comment" >
                                                          <i class="fas fa-comments text-gray mx-10"></i>

                                                      </span>
                                                                    <!--                                                <i class="fas fa-user-plus mx-10"></i>-->
                                                                </b-col>
                                                                <b-col md="6"  class="text-left">






                                                                    <CButton
                                                                            @click="$bvModal.show('modal-issue'+issue.id)"
                                                                            color="secondary"
                                                                            class="btn-sm text-left"
                                                                    >
                                                                        نمایش کامل
                                                                    </CButton>




                                                                    <b-modal style="border: 2px solid yellowgreen!important;"
                                                                             :id="'modal-issue'+issue.id"
                                                                             color="warning"
                                                                             size="xl"
                                                                             :title="issue.title"
                                                                    >






                                                                        <b-col md="12" class="bg-white pt-2" :style="{borderTop: headerStyles(issue)}">

                                                                            <div style="height: 35px">
                                                                                <div>
                                                                                    <!--                                                  <div class="user-image" v-if="issue.public_user.public_profile">-->
                                                                                    <!--                                                      <img v-if="issue.public_user.public_profile.image"-->
                                                                                    <!--                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;-->
                                                                                    <!--                                                  </div>-->
                                                                                    <router-link :to="{path : 'profile/'+issue.public_user.id }" >
                                            <span class="float-right">
                                                <span>
                                                  {{issue.public_user.name}}
                                                </span>
                                                &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>
                                            </span>
                                                                                    </router-link>

                                                                                    <small class="text-color-blue text-left " style="float: left">

                                                                                        <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1">سرنخ/فرصت (Lead)</span>
                                                                                        <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1">ملاقات/جلسه/رویداد</span>
                                                                                        <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1">پیگیری (Ticket)</span>
                                                                                        <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1">ایراد (Bug)</span>
                                                                                        <span v-if="issue.type == 'task'" class="badge badge-success pt-1">فعالیت (Task)</span>
                                                                                        <span v-if="issue.type == 'epic'" class="badge badge-info pt-1">نسخه/فیچر (Epic)</span>
                                                                                        <span v-if="issue.type == 'user-story'" class="badge badge-info pt-1">لیست (User Story)</span>




                                                                                        {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>
                                                                                    </small>
                                                                                </div>
                                                                            </div>

                                                                            <div>

                                                                                <div>


                                                                                    <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>
                                                                                    <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>
                                                                                    <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>



                                                                                    <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"
                                                                                              :style="{backgroundColor: boardColor(issue.board.id)}">
                                                                                        {{issue.board.title}}
                                                                                    </b-badge>

                                                                                    <!--                                                  <small  v-if="issue.public_user.public_profile" class="float-right text-color-gray"> {{issue.public_user.public_profile.education}}-->
                                                                                    <!--                                                  </small>-->
                                                                                    <span class="text-color-gray">

                                                      <b-btn size="sm" variant="outline-secondary">
                                                          سفارش/فاکتور
                                                      </b-btn>

                                                        <b-btn size="sm"  variant="outline-info">
                                                          پروژه: تست
                                                      </b-btn>

                                                       <b-btn size="sm"  variant="outline-primary">
                                                          مشتری: تست
                                                      </b-btn>
                                                                                        <!--                                                <i class="fas fa-heart"></i>&ensp;{{issue.like}}&ensp;&ensp;-->
                                                                                        <!--                                                <i class="fas fa-comments text-gray"></i>&ensp;{{issue.comments.length}}-->
                                            </span>
                                                                                </div>

                                                                            </div>
                                                                            <div>
                                                                                <hr>
                                                                            </div>
                                                                            <div v-if="issue.attaches" class="text-right">

                                                                                <b-carousel id="carousel-1" class="h-100 mb-3" :interval="80000"
                                                                                            no-wrap indicators  background="#eeeeee"
                                                                                            style="text-shadow: 1px 1px 2px #333;">

                                                                                    <b-carousel-slide v-for="(issueFile, fileIndex) in issue.attaches" :key="fileIndex"
                                                                                    >
                                                                                        <template v-slot:img>
                                                                                            <div v-if="issueFile.type == 'image'" class="text-center " style="max-height: 300px;overflow: hidden">
                                                                                                <img :title="issueFile.note"
                                                                                                     :src="'/'+issueFile.file" :alt="issue.title" class="w-100">
                                                                                            </div>


                                                                                            <audio  v-if="issueFile.type == 'voice'" :src="'/'+issueFile.file"
                                                                                                    controls class="w-100 my-4">
                                                                                            </audio>

                                                                                            <video  v-if="issueFile.type == 'video'" class="w-100" controls>
                                                                                                <source :src="'/'+issueFile.file" type="video/mp4">
                                                                                                <source :src="'/'+issueFile.file" type="video/ogg">
                                                                                                Your browser does not support HTML5 video.
                                                                                            </video>

                                                                                            <div  v-if="issueFile.type == 'file'" class="text-center my-5">
                                                                                                <a target="_blank" class="btn btn-info btn-sm " v-if="issueFile.type == 'file'" :href="'/'+issueFile.file" >
                                                                                                    دانلود پیوست
                                                                                                </a>
                                                                                            </div>


                                                                                        </template>
                                                                                    </b-carousel-slide>

                                                                                </b-carousel>

                                                                            </div>


                                                                            <h3 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h3>
                                                                            <!--                                        <pre style="font-family:IRANSans , sans-serif !important " v-html="issue.intro"></pre>-->
                                                                            <p  v-html="issue.description.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="overflow: hidden; direction: rtl!important;text-align: right!important;"></p>
                                                                            <small v-if="issue.text && issue.text != 'null' && issue.text != '0'" v-on:click="showIssueText(issue.text, issueIndex)" style="color: darkgrey;cursor: pointer">نمایش ادامه...</small>





                                                                            <div>
                                                                                <b-row class="mb-2">
                                                                                    <b-col  md="6" class="text-right">


                                                                                        <!--                                                      <span v-on:click="likeIssue(issue)" >-->
                                                                                        <!--&lt;!&ndash;                                                          <i :id="'like-fas-'+issue.id"  v-if="issue.user_like.length" class="fas fa-heart mx-10 "></i>&ndash;&gt;-->
                                                                                        <!--                                                          <i :id="'like-far-'+issue.id"  class="far fa-heart mx-10"></i>-->
                                                                                        <!--                                                      </span>-->

                                                                                        <span v-on:click="issue.comment = !issue.comment" >
                                                          <i class="fas fa-comments text-gray mx-10"></i>

                                                      </span>
                                                                                        <!--                                                <i class="fas fa-user-plus mx-10"></i>-->
                                                                                    </b-col>
                                                                                    <b-col md="6"  class="text-left">





                                                                                        <nav class="nav justify-content-end">
                                                                                            <!--                                                    <a class="position-absolute" href="#" style="left: 20px;"><img-->
                                                                                            <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                                            <!--                                                    <a class="position-absolute" href="#" style="left: 40px;"><img-->
                                                                                            <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                                            <!--                                                    <a class="position-absolute" href="#" style="left: 60px;"><img-->
                                                                                            <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->

                                                                                        </nav>

                                                                                    </b-col>
                                                                                </b-row>






                                                                                <div v-if="issue.comment">
                                                                                    <div>
                                                                                        <b-row  class="text-right  py-1 mx-1 my-1" style="border: 1px solid #eee;border-radius: 4px">


                                                                                            <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                                                <div>
                                                                                                    <v-textarea
                                                                                                            :id="'newComment-'+issue.id"   class=""
                                                                                                            placeholder="نظر خود را وارد کنند…" rows="1"
                                                                                                            :rules="rules"
                                                                                                    ></v-textarea>
                                                                                                    <b-button @click="sendComment(issue.id)" variant="success btn-sm px-1 mt-0"
                                                                                                    >ثبت نظر</b-button>
                                                                                                </div>

                                                                                            </b-col>


                                                                                        </b-row>


                                                                                    </div>


                                                                                    <div v-for="(comment, commentIndex) in issue.comments" :key="commentIndex"
                                                                                    >
                                                                                        <b-row  :id="`popover-1-${comment.id}`" class="text-right  py-1 mx-1 my-1" style="background-color: #eee;border-radius: 4px" >

                                                                                            <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                                                <router-link :to="{path : 'profile/'+comment.public_user.id }"  class="user-image ml-0 pl-0" :title="comment.public_user.name+' '+comment.public_user.family">
                                                                                                    <img v-if="comment.public_user.public_profile.image"
                                                                                                         :src="'/'+comment.public_user.public_profile.image" style="height: 30px" :alt="comment.public_user.name+' '+comment.public_user.family" class="">&ensp;
                                                                                                </router-link>
                                                                                            </b-col>
                                                                                            <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                                                <small  class="mr-0 pr-0 ">
                                                                                                    {{comment.comment}}

                                                                                                </small>
                                                                                            </b-col>
                                                                                        </b-row>


                                                                                        <b-popover
                                                                                                :target="`popover-1-${comment.id}`"
                                                                                                :placement="top"
                                                                                                triggers="hover focus"
                                                                                                :content="`Placement ${comment.id}`"

                                                                                        >
                                                                                            <!--                                                    <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                                            <b-btn v-on:click="showReplyForm(issue.id, comment.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                                        </b-popover>


                                                                                        <b-row :id="'reply-form-'+issue.id+'-'+comment.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                                            <b-col md="12" class="mr-0 py-0  pt-1 mb-1 ">
                                                                                                <div>
                                                                                                    <v-textarea :id="'reply-'+issue.id+'-'+comment.id"
                                                                                                                class=""
                                                                                                                placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                                                :rules="rules"
                                                                                                    ></v-textarea>
                                                                                                    <b-button @click="sendReply(issue.id, comment.id)" variant="success btn-sm px-1 mt-0"
                                                                                                    >ثبت پاسخ</b-button>
                                                                                                    <b-btn class="btn-sm" @click="hideForm(issue.id, comment.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                                                </div>
                                                                                            </b-col>
                                                                                        </b-row>




                                                                                        <div v-for="(reply, replyIndex) in comment.answers" :key="replyIndex"
                                                                                        >
                                                                                            <b-row  :id="`popover-1-${reply.id}`" class="text-right  py-1 mx-1 my-1 mr-5" style="border:1px solid #eee;border-radius: 4px" >

                                                                                                <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                                                    <router-link :to="{path : 'profile/'+reply.public_user.id }"  class="user-image ml-0 pl-0" :title="reply.public_user.name+' '+reply.public_user.family">
                                                                                                        <img v-if="reply.public_user.public_profile.image"
                                                                                                             :src="'/'+reply.public_user.public_profile.image" style="height: 30px" :alt="reply.public_user.name+' '+reply.public_user.family" class="">&ensp;
                                                                                                    </router-link>
                                                                                                </b-col>
                                                                                                <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                                                    <small  class="mr-0 pr-0 ">
                                                                                                        {{reply.comment}}

                                                                                                    </small>
                                                                                                </b-col>
                                                                                            </b-row>


                                                                                            <b-popover
                                                                                                    :target="`popover-1-${reply.id}`"
                                                                                                    :placement="top"
                                                                                                    triggers="hover focus"
                                                                                                    :content="`Placement ${reply.id}`"

                                                                                            >
                                                                                                <!--                                                        <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                                                <b-btn v-on:click="showReplyForm(issue.id, reply.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                                            </b-popover>


                                                                                            <b-row :id="'reply-form-'+issue.id+'-'+reply.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                                                <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                                                    <div>
                                                                                                        <v-textarea :id="'reply-'+issue.id+'-'+reply.id"
                                                                                                                    class=""
                                                                                                                    placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                                                    :rules="rules"
                                                                                                        ></v-textarea>
                                                                                                        <b-button @click="sendReplyOfReply(issue.id, comment.id,reply.id)" variant="success btn-sm px-1 mt-0"
                                                                                                        >ثبت پاسخ</b-button>
                                                                                                        <b-btn class="btn-sm" @click="hideForm(issue.id, reply.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                                                    </div>
                                                                                                </b-col>
                                                                                            </b-row>

                                                                                        </div>









                                                                                    </div>


                                                                                    <small style="cursor: pointer" @click="getMoreComments(issue.id)">نظرات بیشتر</small>


                                                                                </div>




                                                                            </div>
                                                                        </b-col>







                                                                        <b-row class="my-4 ml-1 mr-5 pr-5">

                                                                            <b-col md="12" class="bg-white ml-1" style="border-bottom: 4px solid #eee">
                                                                                <div>
                                                                                    <div>

                                                                                        <b-input
                                                                                                v-model="newIssue.title" class="my-1 mt-2"
                                                                                                placeholder="عنوان" rows="2"
                                                                                                :rules="rules"
                                                                                        ></b-input>
                                                                                        <b-textarea v-if="newIssue.title"
                                                                                                    v-model="newIssue.intro" id="textarea-rows" class="my-1 mt-2"
                                                                                                    placeholder="توضیحات ..." rows="2"
                                                                                                    :rules="rules"
                                                                                        ></b-textarea>



                                                                                        <b-row  v-if="newIssue.title">

                                                                                            <b-col  md="5">
                                                                                                <b-form-select v-model="newIssue.type"  size="sm" class="mt-2" style="direction: ltr">

                                                                                                    <b-form-select-option  value="lead" style="color: #f50057">سرنخ/فرصت (Lead)</b-form-select-option>
                                                                                                    <b-form-select-option  value="meeting" style="color: #8e24aa">ملاقات/جلسه/رویداد</b-form-select-option>
                                                                                                    <b-form-select-option  value="ticket" style="color: #263238" >پیگیری (Ticket)</b-form-select-option>
                                                                                                    <b-form-select-option  value="bug" style="color: #dd2c00">ایراد (Bug)</b-form-select-option>
                                                                                                    <b-form-select-option  value="task" style="color: #00c853">فعالیت (Task)</b-form-select-option>
                                                                                                    <b-form-select-option  value="user-story" style="color: #0097a7">لیست (User Story)</b-form-select-option>
                                                                                                    <b-form-select-option  value="epic" style="color: #0288d1">نسخه/فیچر (Epic)</b-form-select-option>
                                                                                                    <b-form-select-option  value="etc" style="color: #888888">سایر</b-form-select-option>


                                                                                                </b-form-select>
                                                                                            </b-col>

                                                                                            <b-col  md="4">
                                                                                                <b-form-select
                                                                                                        v-c-tooltip="{
        content: '<strong>وضعیت</strong>',
        placement: 'left'
      }"
                                                                                                        v-model="newIssue.board_id"  size="sm" class="mt-2"  style="direction: ltr">

                                                                                                    <b-form-select-option  value="1"  style="color: #ffab00">(Open) باز شده</b-form-select-option>
                                                                                                    <b-form-select-option  value="2"  style="color: #ffd600">(To DO) جهت انجام</b-form-select-option>
                                                                                                    <b-form-select-option  value="3"  style="color: #aeea00">درحال انجام (Doing)</b-form-select-option>
                                                                                                    <b-form-select-option  value="4"  style="color: #64dd17">جهت بازبینی (Review)</b-form-select-option>
                                                                                                    <b-form-select-option  value="5"  style="color: #00bfa5">انجام شده (Done)</b-form-select-option>




                                                                                                </b-form-select>
                                                                                            </b-col>

                                                                                            <b-col  md="3">
                                                                                                <b-form-select title="وضعیت" v-model="newIssue.priority"  size="sm" class="mt-2"  style="direction: ltr">

                                                                                                    <b-form-select-option  value="3" >  اولویت زیاد</b-form-select-option>
                                                                                                    <b-form-select-option  value="2" >  اولویت متوسط</b-form-select-option>
                                                                                                    <b-form-select-option  value="1" >  اولویت کم</b-form-select-option>



                                                                                                </b-form-select>
                                                                                            </b-col>



                                                                                            <!--                                                                              <b-col  md="5" class="mt-3 mb-2">-->
                                                                                            <!--                                                                                  &lt;!&ndash;                                                          <b-form-select v-model="newIssue.type"  size="sm" class="mt-2"  style="direction: ltr">&ndash;&gt;-->
                                                                                            <!--                                                                                  &lt;!&ndash;                                                              <b-form-select-option  value="null" >پروژه نامشخص</b-form-select-option>&ndash;&gt;-->
                                                                                            <!--                                                                                  &lt;!&ndash;                                                          </b-form-select>&ndash;&gt;-->

                                                                                            <!--                                                                                  <multiselect v-model="newIssue.project_id"  @select="setForumId($event)"  :options="options"-->
                                                                                            <!--                                                                                               placeholder=" انتخاب پروژه" label="title" track-by="title">-->
                                                                                            <!--                                                                                  </multiselect>-->
                                                                                            <!--                                                                              </b-col>-->



                                                                                            <b-col  md="12" class="mt-3 mb-2">
                                                                                                <multiselect   v-model="newIssue.users" :height="300" :options="options" :multiple="true"
                                                                                                               :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                                                                               :custom-label="customLabel"
                                                                                                               :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                                                                               tag-placeholder="اختصاص کاربر" placeholder="اختصاص کاربر"
                                                                                                               label="title" track-by="title" :preselect-first="false"

                                                                                                               @tag="addTag">

                                                                                                </multiselect>
                                                                                            </b-col>

                                                                                        </b-row>

                                                                                    </div>


                                                                                    <div class="row my-2">
                                                                                        <div class="col-6 " style="display: flex;justify-content: right">
                                                                                            <b-button @click="createIssue()" variant="primary btn-sm px-1 mt-0"
                                                                                            >ثبت زیر پست (Sub Issue) </b-button>
                                                                                        </div>

                                                                                        <ul   v-if="newIssue.title" class="ul-upload mt-1 mb-0 col-6">
                                                                                            <li class="li-upload mr-1 mt-2 c-pointer"  @click="showVoiceRecorder = !showVoiceRecorder"><i class="fas fa-microphone"></i></li>
                                                                                            <li class="li-upload mr-1 mt-2 c-pointer"  @click="showImageUploader = !showImageUploader"><i class="fas fa-image"></i></li>
                                                                                            <li class="li-upload mr-1 mt-2 c-pointer"  @click="showVideoUploader = !showVideoUploader"><i class="fas fa-film"></i></li>
                                                                                            <li class="li-upload mr-1 mt-2 c-pointer"  @click="showFileUploader = !showFileUploader"><i class="fas fa-paperclip"></i></li>
                                                                                            <li class="li-upload mr-2"  >
                                                                                                <b-button v-b-toggle.collapse-1  size="sm">
                                                                                                    <i class="fas fa-bars" aria-hidden="true"></i>
                                                                                                </b-button>
                                                                                            </li>
                                                                                        </ul>

                                                                                        <div v-if="showVoiceRecorder" class="d-flex justify-content-center w-100 px-2 my-1">
                                                                                            <!--                                                <audio-recorder-->
                                                                                            <!--                                                        v-model="newIssue.voice"-->
                                                                                            <!--                                                        :attempts="1"-->
                                                                                            <!--                                                        :time="2"-->
                                                                                            <!--                                                        :show-upload-button="false"-->
                                                                                            <!--                                                        :before-recording="callback"-->
                                                                                            <!--                                                        :pause-recording="callback"-->
                                                                                            <!--                                                        :after-recording="callback"-->
                                                                                            <!--                                                        :select-record="callback"-->
                                                                                            <!--                                                        :before-upload="callback"-->
                                                                                            <!--                                                        :successful-upload="callback"-->
                                                                                            <!--                                                        :failed-upload="callback"/>-->

                                                                                            <vue-record-audio  v-model="newIssue.voice" @result="onResult"  />

                                                                                            <audio  :src="srcPlay"  controls class="w-100 mr-2 mt-1">
                                                                                            </audio>

                                                                                        </div>





                                                                                        <div v-if="showFileUploader" class="d-flex justify-content-center w-100 px-5 my-1" >

                                                                                            <div class="ar">
                                                                                                <label>فایل را انتخاب کنید</label>

                                                                                                <b-form-file v-model="newIssue.file" placeholder="فایل را انتخاب کنید" drop-placeholder="Drop file here..."
                                                                                                             plain>
                                                                                                </b-form-file>
                                                                                                <!--                                                          <div class="text-center my-2" v-if="newIssue.file">-->
                                                                                                <!--                                                              <b-form-checkbox v-model="newIssue.fileLib"  :disabled="IssueAsForum" name="check-button" switch class="d-inline" ></b-form-checkbox>-->
                                                                                                <!--                                                              <span  class="mr-1"  style="color: #e65100">انتشار فایل در کتابخانه</span>-->
                                                                                                <!--                                                          </div>-->
                                                                                            </div>

                                                                                        </div>




                                                                                        <div v-if="showImageUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                                                                            <div class="ar " >
                                                                                                <label>تصویر را انتخاب کنید</label>
                                                                                                <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                                                                                <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                                                                                <b-form-file v-model="newIssue.image" placeholder="تصویر را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                                                                                </b-form-file>

                                                                                                <!--                                                    <input type="file" class="" ref="file" @change="onFileChangeImage($event)"-->
                                                                                                <!--                                                           placeholder="تصویر را انتخاب کنید"/>-->


                                                                                            </div>

                                                                                        </div>



                                                                                        <div v-if="showVideoUploader" class="d-flex justify-content-center w-100 px-5 my-1">

                                                                                            <div class="ar" >
                                                                                                <label>ویدئو را انتخاب کنید</label>
                                                                                                <!-- <ckeditor value="Hello, World!"></ckeditor> -->
                                                                                                <!--                                                    <ckeditor id="editor"  v-model="editorData" :config="editorConfig"></ckeditor>-->
                                                                                                <b-form-file  v-model="newIssue.video" placeholder="ویدئو را انتخاب کنید" drop-placeholder="Drop file here..." plain>
                                                                                                </b-form-file>
                                                                                            </div>

                                                                                        </div>





                                                                                    </div>



                                                                                    <div>

                                                                                        <b-collapse id="collapse-1" class="mt-2 text-right">
                                                                                            <b-card>
                                                                                                <!--                                                          <b-form-select v-model="selected" :options="typeOptions" size="sm" class="mt-3"></b-form-select>-->



                                                                                                <b-row  v-if="newIssue.title">

                                                                                                    <b-col  md="7">

                                                                                                        <custom-time-picker  v-model="newIssue.due_date"
                                                                                                                             type="datetime" :clearable="true" placeholder="زمان انجام" min="" max="">
                                                                                                        </custom-time-picker>
                                                                                                    </b-col>

                                                                                                    <b-col  md="5" >

                                                                                                        <b-input
                                                                                                                v-model="newIssue.estimated_time"
                                                                                                                placeholder="مدت تخمینی (دقیقه)"
                                                                                                                type="number"
                                                                                                        ></b-input>
                                                                                                    </b-col>



                                                                                                    <b-col  md="12" class="mt-2">

                                                                                                        <multiselect  v-model="newIssue.tags" :height="300" :options="options" :multiple="true"
                                                                                                                      :taggable="true" :close-on-select="false" :clear-on-select="false"
                                                                                                                      :custom-label="customLabel"
                                                                                                                      :preserve-search="true" :hide-selected="true" :show-labels="false"
                                                                                                                      tag-placeholder="افزودن تگ جدید" placeholder="برچست (تگ)"
                                                                                                                      label="title" track-by="title" :preselect-first="false"

                                                                                                                      @tag="addTag">
                                                                                                        </multiselect>
                                                                                                    </b-col>
                                                                                                </b-row>






                                                                                            </b-card>
                                                                                        </b-collapse>
                                                                                    </div>



                                                                                </div>
                                                                            </b-col>
                                                                        </b-row>






                                                                        <b-row v-for="(issue, issueIndex) in issues" :key="issueIndex" class="my-4 ml-1 mr-5 pr-5"
                                                                        >

                                                                            <b-col md="12" class="bg-white pt-2" :style="{borderTop: headerStyles(issue)}">

                                                                                <div style="height: 35px">
                                                                                    <div>
                                                                                        <!--                                                  <div class="user-image" v-if="issue.public_user.public_profile">-->
                                                                                        <!--                                                      <img v-if="issue.public_user.public_profile.image"-->
                                                                                        <!--                                                           :src="'/'+issue.public_user.public_profile.image" style="height: 30px" :alt="issue.public_user.name+' '+issue.public_user.family" class="">&ensp;-->
                                                                                        <!--                                                  </div>-->
                                                                                        <router-link :to="{path : 'profile/'+issue.public_user.id }" >
                                            <span class="float-right">
                                                <span>
                                                  {{issue.public_user.name}}
                                                </span>
                                                &ensp;<i v-if="2==3" class="fas fa-check-circle text-color-blue"></i>
                                            </span>
                                                                                        </router-link>

                                                                                        <small class="text-color-blue text-left " style="float: left">

                                                                                            <span v-if="issue.type == 'lead'" class="badge badge-secondary pt-1">سرنخ/فرصت (Lead)</span>
                                                                                            <span v-if="issue.type == 'meeting'" class="badge badge-secondary pt-1">ملاقات/جلسه/رویداد</span>
                                                                                            <span v-if="issue.type == 'ticket'" class="badge badge-secondary pt-1">پیگیری (Ticket)</span>
                                                                                            <span v-if="issue.type == 'bug'" class="badge badge-danger pt-1">ایراد (Bug)</span>
                                                                                            <span v-if="issue.type == 'task'" class="badge badge-success pt-1">فعالیت (Task)</span>
                                                                                            <span v-if="issue.type == 'epic'" class="badge badge-info pt-1">نسخه/فیچر (Epic)</span>
                                                                                            <span v-if="issue.type == 'user-story'" class="badge badge-info pt-1">لیست (User Story)</span>




                                                                                            {{issue.created_at| moment("dddd, jD jMMMM  jYYYY") }} <i class="far fa-clock"></i>
                                                                                        </small>
                                                                                    </div>
                                                                                </div>

                                                                                <div>
                                                                                    <div>


                                                                                        <b-badge v-if="issue.priority == 3"  pill class="text-left p-1 mr-2" style="background-color: #212121;border: 1px solid #880e4f;float: left">اولویت زیاد</b-badge>
                                                                                        <b-badge v-else-if="issue.priority == 2"   pill class="text-left p-1 mr-2" style="background-color: #757575;float: left">اولویت متوسط</b-badge>
                                                                                        <b-badge v-else-if="issue.priority == 1"  pill  class="text-left p-1 mr-2" style="background-color: #9e9e9e;float: left">اولویت کم</b-badge>



                                                                                        <b-badge  v-if="issue.board" pill variant="info" class="text-left p-1" style="float: left"
                                                                                                  :style="{backgroundColor: boardColor(issue.board.id)}">
                                                                                            {{issue.board.title}}
                                                                                        </b-badge>

                                                                                        <!--                                                  <small  v-if="issue.public_user.public_profile" class="float-right text-color-gray"> {{issue.public_user.public_profile.education}}-->
                                                                                        <!--                                                  </small>-->
                                                                                        <span class="text-color-gray">

                                                      <b-btn size="sm" variant="outline-secondary">
                                                          سفارش/فاکتور
                                                      </b-btn>

                                                        <b-btn size="sm"  variant="outline-info">
                                                          پروژه: تست
                                                      </b-btn>

                                                       <b-btn size="sm"  variant="outline-primary">
                                                          مشتری: تست
                                                      </b-btn>
                                                                                            <!--                                                <i class="fas fa-heart"></i>&ensp;{{issue.like}}&ensp;&ensp;-->
                                                                                            <!--                                                <i class="fas fa-comments text-gray"></i>&ensp;{{issue.comments.length}}-->
                                            </span>
                                                                                    </div>

                                                                                </div>
                                                                                <div>
                                                                                    <hr>
                                                                                </div>
                                                                                <div v-if="issue.attaches" class="text-right">

                                                                                    <b-carousel id="carousel-1" class="h-100 mb-3" :interval="80000"
                                                                                                no-wrap indicators  background="#eeeeee"
                                                                                                style="text-shadow: 1px 1px 2px #333;">

                                                                                        <b-carousel-slide v-for="(issueFile, fileIndex) in issue.attaches" :key="fileIndex"
                                                                                        >
                                                                                            <template v-slot:img>
                                                                                                <div v-if="issueFile.type == 'image'" class="text-center " style="max-height: 300px;overflow: hidden">
                                                                                                    <img :title="issueFile.note"
                                                                                                         :src="'/'+issueFile.file" :alt="issue.title" class="w-100">
                                                                                                </div>


                                                                                                <audio  v-if="issueFile.type == 'voice'" :src="'/'+issueFile.file"
                                                                                                        controls class="w-100 my-4">
                                                                                                </audio>

                                                                                                <video  v-if="issueFile.type == 'video'" class="w-100" controls>
                                                                                                    <source :src="'/'+issueFile.file" type="video/mp4">
                                                                                                    <source :src="'/'+issueFile.file" type="video/ogg">
                                                                                                    Your browser does not support HTML5 video.
                                                                                                </video>

                                                                                                <div  v-if="issueFile.type == 'file'" class="text-center my-5">
                                                                                                    <a target="_blank" class="btn btn-info btn-sm " v-if="issueFile.type == 'file'" :href="'/'+issueFile.file" >
                                                                                                        دانلود پیوست
                                                                                                    </a>
                                                                                                </div>


                                                                                            </template>
                                                                                        </b-carousel-slide>

                                                                                    </b-carousel>

                                                                                </div>


                                                                                <h3 v-if="issue.title && issue.title != 'null' && issue.title != '0'">{{issue.title}}</h3>
                                                                                <!--                                        <pre style="font-family:IRANSans , sans-serif !important " v-html="issue.intro"></pre>-->
                                                                                <p  v-html="issue.description.replace(/(?:\r\n|\r|\n)/g, '<br>')" style="overflow: hidden; direction: rtl!important;text-align: right!important;"></p>
                                                                                <small v-if="issue.text && issue.text != 'null' && issue.text != '0'" v-on:click="showIssueText(issue.text, issueIndex)" style="color: darkgrey;cursor: pointer">نمایش ادامه...</small>





                                                                                <div>
                                                                                    <b-row class="mb-2">
                                                                                        <b-col  md="6" class="text-right">


                                                                                            <!--                                                      <span v-on:click="likeIssue(issue)" >-->
                                                                                            <!--&lt;!&ndash;                                                          <i :id="'like-fas-'+issue.id"  v-if="issue.user_like.length" class="fas fa-heart mx-10 "></i>&ndash;&gt;-->
                                                                                            <!--                                                          <i :id="'like-far-'+issue.id"  class="far fa-heart mx-10"></i>-->
                                                                                            <!--                                                      </span>-->

                                                                                            <span v-on:click="issue.comment = !issue.comment" >
                                                          <i class="fas fa-comments text-gray mx-10"></i>

                                                      </span>
                                                                                            <!--                                                <i class="fas fa-user-plus mx-10"></i>-->
                                                                                        </b-col>
                                                                                        <b-col md="6"  class="text-left">




                                                                                            <!--                                                                              <CButton-->
                                                                                            <!--                                                                                      @click="$bvModal.show('modal-issue'+issue.id)"-->
                                                                                            <!--                                                                                      color="secondary"-->
                                                                                            <!--                                                                                      class="btn-sm text-left"-->
                                                                                            <!--                                                                              >-->
                                                                                            <!--                                                                                  نمایش کامل-->
                                                                                            <!--                                                                              </CButton>-->
                                                                                            <!--                                                                              <b-modal style="border: 2px solid yellowgreen!important;"-->
                                                                                            <!--                                                                                       :id="'modal-issue'+issue.id"-->
                                                                                            <!--                                                                                       color="warning"-->
                                                                                            <!--                                                                                       size="xl"-->
                                                                                            <!--                                                                              >-->
                                                                                            <!--                                                                                  <div class="modal-title">dd</div>-->
                                                                                            <!--                                                                                  {{issue.title}}-->
                                                                                            <!--                                                                              </b-modal>-->

                                                                                            <nav class="nav justify-content-end">
                                                                                                <!--                                                    <a class="position-absolute" href="#" style="left: 20px;"><img-->
                                                                                                <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                                                <!--                                                    <a class="position-absolute" href="#" style="left: 40px;"><img-->
                                                                                                <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                                                <!--                                                    <a class="position-absolute" href="#" style="left: 60px;"><img-->
                                                                                                <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->

                                                                                            </nav>

                                                                                        </b-col>
                                                                                    </b-row>






                                                                                    <div v-if="issue.comment">
                                                                                        <div>
                                                                                            <b-row  class="text-right  py-1 mx-1 my-1" style="border: 1px solid #eee;border-radius: 4px">


                                                                                                <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                                                    <div>
                                                                                                        <v-textarea
                                                                                                                :id="'newComment-'+issue.id"   class=""
                                                                                                                placeholder="نظر خود را وارد کنند…" rows="1"
                                                                                                                :rules="rules"
                                                                                                        ></v-textarea>
                                                                                                        <b-button @click="sendComment(issue.id)" variant="success btn-sm px-1 mt-0"
                                                                                                        >ثبت نظر</b-button>
                                                                                                    </div>

                                                                                                </b-col>


                                                                                            </b-row>


                                                                                        </div>


                                                                                        <div v-for="(comment, commentIndex) in issue.comments" :key="commentIndex"
                                                                                        >
                                                                                            <b-row  :id="`popover-1-${comment.id}`" class="text-right  py-1 mx-1 my-1" style="background-color: #eee;border-radius: 4px" >

                                                                                                <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                                                    <router-link :to="{path : 'profile/'+comment.public_user.id }"  class="user-image ml-0 pl-0" :title="comment.public_user.name+' '+comment.public_user.family">
                                                                                                        <img v-if="comment.public_user.public_profile.image"
                                                                                                             :src="'/'+comment.public_user.public_profile.image" style="height: 30px" :alt="comment.public_user.name+' '+comment.public_user.family" class="">&ensp;
                                                                                                    </router-link>
                                                                                                </b-col>
                                                                                                <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                                                    <small  class="mr-0 pr-0 ">
                                                                                                        {{comment.comment}}

                                                                                                    </small>
                                                                                                </b-col>
                                                                                            </b-row>


                                                                                            <b-popover
                                                                                                    :target="`popover-1-${comment.id}`"
                                                                                                    :placement="top"
                                                                                                    triggers="hover focus"
                                                                                                    :content="`Placement ${comment.id}`"

                                                                                            >
                                                                                                <!--                                                    <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                                                <b-btn v-on:click="showReplyForm(issue.id, comment.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                                            </b-popover>


                                                                                            <b-row :id="'reply-form-'+issue.id+'-'+comment.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                                                <b-col md="12" class="mr-0 py-0  pt-1 mb-1 ">
                                                                                                    <div>
                                                                                                        <v-textarea :id="'reply-'+issue.id+'-'+comment.id"
                                                                                                                    class=""
                                                                                                                    placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                                                    :rules="rules"
                                                                                                        ></v-textarea>
                                                                                                        <b-button @click="sendReply(issue.id, comment.id)" variant="success btn-sm px-1 mt-0"
                                                                                                        >ثبت پاسخ</b-button>
                                                                                                        <b-btn class="btn-sm" @click="hideForm(issue.id, comment.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                                                    </div>
                                                                                                </b-col>
                                                                                            </b-row>




                                                                                            <div v-for="(reply, replyIndex) in comment.answers" :key="replyIndex"
                                                                                            >
                                                                                                <b-row  :id="`popover-1-${reply.id}`" class="text-right  py-1 mx-1 my-1 mr-5" style="border:1px solid #eee;border-radius: 4px" >

                                                                                                    <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                                                        <router-link :to="{path : 'profile/'+reply.public_user.id }"  class="user-image ml-0 pl-0" :title="reply.public_user.name+' '+reply.public_user.family">
                                                                                                            <img v-if="reply.public_user.public_profile.image"
                                                                                                                 :src="'/'+reply.public_user.public_profile.image" style="height: 30px" :alt="reply.public_user.name+' '+reply.public_user.family" class="">&ensp;
                                                                                                        </router-link>
                                                                                                    </b-col>
                                                                                                    <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                                                        <small  class="mr-0 pr-0 ">
                                                                                                            {{reply.comment}}

                                                                                                        </small>
                                                                                                    </b-col>
                                                                                                </b-row>


                                                                                                <b-popover
                                                                                                        :target="`popover-1-${reply.id}`"
                                                                                                        :placement="top"
                                                                                                        triggers="hover focus"
                                                                                                        :content="`Placement ${reply.id}`"

                                                                                                >
                                                                                                    <!--                                                        <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                                                    <b-btn v-on:click="showReplyForm(issue.id, reply.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                                                </b-popover>


                                                                                                <b-row :id="'reply-form-'+issue.id+'-'+reply.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                                                    <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                                                        <div>
                                                                                                            <v-textarea :id="'reply-'+issue.id+'-'+reply.id"
                                                                                                                        class=""
                                                                                                                        placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                                                        :rules="rules"
                                                                                                            ></v-textarea>
                                                                                                            <b-button @click="sendReplyOfReply(issue.id, comment.id,reply.id)" variant="success btn-sm px-1 mt-0"
                                                                                                            >ثبت پاسخ</b-button>
                                                                                                            <b-btn class="btn-sm" @click="hideForm(issue.id, reply.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                                                        </div>
                                                                                                    </b-col>
                                                                                                </b-row>

                                                                                            </div>









                                                                                        </div>


                                                                                        <small style="cursor: pointer" @click="getMoreComments(issue.id)">نظرات بیشتر</small>


                                                                                    </div>




                                                                                </div>
                                                                            </b-col>
                                                                        </b-row>


                                                                    </b-modal>







                                                                    <nav class="nav justify-content-end">
                                                                        <!--                                                    <a class="position-absolute" href="#" style="left: 20px;"><img-->
                                                                        <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                        <!--                                                    <a class="position-absolute" href="#" style="left: 40px;"><img-->
                                                                        <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->
                                                                        <!--                                                    <a class="position-absolute" href="#" style="left: 60px;"><img-->
                                                                        <!--                                                            src="/image/Avatar.png" alt="Image 1" class=""></a>-->

                                                                    </nav>

                                                                </b-col>
                                                            </b-row>






                                                            <div v-if="issue.comment">
                                                                <div>
                                                                    <b-row  class="text-right  py-1 mx-1 my-1" style="border: 1px solid #eee;border-radius: 4px">


                                                                        <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                            <div>
                                                                                <v-textarea
                                                                                        :id="'newComment-'+issue.id"   class=""
                                                                                        placeholder="نظر خود را وارد کنند…" rows="1"
                                                                                        :rules="rules"
                                                                                ></v-textarea>
                                                                                <b-button @click="sendComment(issue.id)" variant="success btn-sm px-1 mt-0"
                                                                                >ثبت نظر</b-button>
                                                                            </div>

                                                                        </b-col>


                                                                    </b-row>


                                                                </div>


                                                                <div v-for="(comment, commentIndex) in issue.comments" :key="commentIndex"
                                                                >
                                                                    <b-row  :id="`popover-1-${comment.id}`" class="text-right  py-1 mx-1 my-1" style="background-color: #eee;border-radius: 4px" >

                                                                        <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                            <router-link :to="{path : 'profile/'+comment.public_user.id }"  class="user-image ml-0 pl-0" :title="comment.public_user.name+' '+comment.public_user.family">
                                                                                <img v-if="comment.public_user.public_profile.image"
                                                                                     :src="'/'+comment.public_user.public_profile.image" style="height: 30px" :alt="comment.public_user.name+' '+comment.public_user.family" class="">&ensp;
                                                                            </router-link>
                                                                        </b-col>
                                                                        <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                            <small  class="mr-0 pr-0 ">
                                                                                {{comment.comment}}

                                                                            </small>
                                                                        </b-col>
                                                                    </b-row>


                                                                    <b-popover
                                                                            :target="`popover-1-${comment.id}`"
                                                                            :placement="top"
                                                                            triggers="hover focus"
                                                                            :content="`Placement ${comment.id}`"

                                                                    >
                                                                        <!--                                                    <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                        <b-btn v-on:click="showReplyForm(issue.id, comment.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                    </b-popover>


                                                                    <b-row :id="'reply-form-'+issue.id+'-'+comment.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                        <b-col md="12" class="mr-0 py-0  pt-1 mb-1 ">
                                                                            <div>
                                                                                <v-textarea :id="'reply-'+issue.id+'-'+comment.id"
                                                                                            class=""
                                                                                            placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                            :rules="rules"
                                                                                ></v-textarea>
                                                                                <b-button @click="sendReply(issue.id, comment.id)" variant="success btn-sm px-1 mt-0"
                                                                                >ثبت پاسخ</b-button>
                                                                                <b-btn class="btn-sm" @click="hideForm(issue.id, comment.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                            </div>
                                                                        </b-col>
                                                                    </b-row>




                                                                    <div v-for="(reply, replyIndex) in comment.answers" :key="replyIndex"
                                                                    >
                                                                        <b-row  :id="`popover-1-${reply.id}`" class="text-right  py-1 mx-1 my-1 mr-5" style="border:1px solid #eee;border-radius: 4px" >

                                                                            <b-col md="2" class="ml-0 pl-0 py-0  my-0"  >
                                                                                <router-link :to="{path : 'profile/'+reply.public_user.id }"  class="user-image ml-0 pl-0" :title="reply.public_user.name+' '+reply.public_user.family">
                                                                                    <img v-if="reply.public_user.public_profile.image"
                                                                                         :src="'/'+reply.public_user.public_profile.image" style="height: 30px" :alt="reply.public_user.name+' '+reply.public_user.family" class="">&ensp;
                                                                                </router-link>
                                                                            </b-col>
                                                                            <b-col md="10" class="mr-0 py-0  pt-1 pb-0 my-0">
                                                                                <small  class="mr-0 pr-0 ">
                                                                                    {{reply.comment}}

                                                                                </small>
                                                                            </b-col>
                                                                        </b-row>


                                                                        <b-popover
                                                                                :target="`popover-1-${reply.id}`"
                                                                                :placement="top"
                                                                                triggers="hover focus"
                                                                                :content="`Placement ${reply.id}`"

                                                                        >
                                                                            <!--                                                        <b-btn class="btn btn-sm"><i class="fas fa-ban"></i></b-btn>-->
                                                                            <b-btn v-on:click="showReplyForm(issue.id, reply.id)" class="btn  btn-info btn-sm"><i class="fas fa-reply"></i></b-btn>

                                                                        </b-popover>


                                                                        <b-row :id="'reply-form-'+issue.id+'-'+reply.id" class="text-right  py-1 mx-1 my-1 pr-5" style="border: 1px solid #eee;border-radius: 4px; display: none">
                                                                            <b-col md="12" class="mr-0 py-0  pt-1 mb-1">
                                                                                <div>
                                                                                    <v-textarea :id="'reply-'+issue.id+'-'+reply.id"
                                                                                                class=""
                                                                                                placeholder="پاسخ خود را وارد کنند…" rows="1"
                                                                                                :rules="rules"
                                                                                    ></v-textarea>
                                                                                    <b-button @click="sendReplyOfReply(issue.id, comment.id,reply.id)" variant="success btn-sm px-1 mt-0"
                                                                                    >ثبت پاسخ</b-button>
                                                                                    <b-btn class="btn-sm" @click="hideForm(issue.id, reply.id)"><i class="fas fa-minus-square"></i></b-btn>

                                                                                </div>
                                                                            </b-col>
                                                                        </b-row>

                                                                    </div>









                                                                </div>


                                                                <small style="cursor: pointer" @click="getMoreComments(issue.id)">نظرات بیشتر</small>


                                                            </div>




                                                        </div>
                                                    </b-col>
                                                </div>
                                            </td>

                                        </tr>


                                        <!--<template v-for="item in items">-->
                                        <!--<tr></tr>-->
                                        <!--<tr class="detail-row"></tr>-->
                                        <!--</template>-->
                                        </tbody>




                                        <scroll-loader v-if="loadMore"  :loader-method="getMoreIssues" :loader-enable="loadMore">
                                        </scroll-loader>

                                    </table>
                                </b-col>
                            </b-row>

                        </b-col>





                    </b-row>


                </CCard>



                <CCard>
                    <div class="tab-content">


                        <!-- /.tab-pane -->
                        <div class="active tab-pane" id="timeline">
                            <!-- The timeline -->
                            <ul class="timeline timeline-inverse" v-if="contact.user">
                                <!-- timeline time label -->



                                <!--<li class="time-label">-->
                                <!--<span class="">-->
                                <!--۱۲ اردیبهشت 1398-->
                                <!--</span>-->
                                <!--</li>-->
                                <!-- /.timeline-label -->
                                <!-- timeline item -->
                                <li v-for="(item, index) in contact.user.orders" :key="index">

                                    <!--<i class="fa fa-envelope bg-blue"></i>-->

                                    <div class="">
                                        <hr>

                                        <h6 class="">
                                            رسید فاکتور به مبلغ:

                                            <b>{{spliceNumber(item.final_price)}}</b>
                                            {{$curency}}   </h6>

                                        <div class="timeline-body p-2">
                                             تاریخ:
                                            {{item.general_date | moment("jYYYY/jMM/jDD") }}
                                            <br>





                                            <table class="table table-striped  table-bordered  table-sm " >
                                                <thead>
                                                <tr>
                                                    <th>عنوان</th>
<!--                                                    <th>{{ $t('start time') }}</th>-->
<!--                                                    <th>{{ $t('End Time') }}</th>-->
                                                    <th>فی</th>
                                                    <th>مقدار/تعداد</th>
                                                    <th>قیمت</th>

                                                    <th> {{ $t('Description') }}</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr v-for="(product ,index) in item.order_products"
                                                    :key="index">
                                                    <td>{{ product.product.title }}</td>
                                                    <!--                                                    <td>{{  service.start}}</td>-->
                                                    <!--                                                    <td>{{ service.end }}</td>-->
                                                    <td>{{ spliceNumber(product.price) }}</td>
                                                    <td :title="product.product.unit">{{ product.amount }}</td>
                                                    <td>{{ spliceNumber(product.price*product.amount)  }}</td>

                                                    <td>
                                                        <small>{{product.note}}</small>

                                                    </td>
                                                </tr>

                                                <tr v-for="(service ,index) in item.order_services"
                                                    :key="index">
                                                    <td>{{ service.service.title }}</td>
<!--                                                    <td>{{  service.start}}</td>-->
<!--                                                    <td>{{ service.end }}</td>-->
                                                    <td>{{ service.price }}</td>

                                                    <td>
                                                        <span>{{service.note}}</span>

                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>



                                            {{item.description}}
                                        </div>
                                        <div class="timeline-footer">


                                            <router-link :to="{path: '/order/payment/'+item.id, params: {id: item.id}}"
                                                         class="btn btn-primary btn-xs">
                                                {{ $t('Receipt Request') }}
                                            </router-link>


                                        </div>
                                    </div>
                                </li>


                                <li>
                                    <!--<i class="fa fa-clock-o bg-gray"></i>-->
                                    <i class="fa fa-envelope bg-blue"></i>

                                </li>
                            </ul>
                        </div>
                        <!-- /.tab-pane -->

                        <div class="tab-pane" id="settings">
                            <div class="row mx">
                                <form class="form-horizontal col-xs-12">
                                    <div class="form-group">
                                        <label class="mb-5 control-label">{{ $t('Name') }} </label>

                                        <div class="">
                                            <input type="text" class="form-control " v-model="contact.first_name"
                                                   placeholder="نام">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="mb-5 control-label"> {{ $t('surname') }}</label>

                                        <div class="">
                                            <input type="text" class="form-control" v-model="contact.last_name"
                                                   :placeholder="$t('surname')">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="mb-5 control-label">{{ $t('e-mail') }} </label>

                                        <div class="">
                                            <input type="email" class="form-control" v-model="contact.email"
                                                   :placeholder="$t('e-mail')">
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="mb-5 control-label">{{ $t('Mobile') }}</label>

                                        <div class="">
                                            <input type="text" class="form-control" v-model="contact.mobile"
                                                   :placeholder="$t('Mobile')">
                                        </div>
                                    </div>



                                    <div class="form-group">
                                        <label class="mb-5 control-label">{{ $t('phone') }} / {{$t('Mobile')}} </label>

                                        <div class="">
                                            <input type="text" class="form-control" v-model="contact.tell"
                                                   :placeholder="$t('phone')">
                                        </div>
                                    </div>

                                    <!-- <div class="form-group">
                                    <label class="mb-5 control-label">ویژگی ها</label>

                                    <div class="">
                                    <textarea class="form-control"  placeholder="ویژگی ها"></textarea>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label  class="mb-5 control-label">ویژگی ها</label>

                                    <div class="">
                                    <input type="text" class="form-control"  placeholder="ویژگی ها">
                                    </div>
                                </div> -->
                                    <!-- <div class="form-group">
                                    <div class="col-sm-offset-2 col-sm-10">
                                    <div class="checkbox">
                                        <label>
                                        <input type="checkbox">  <a href="javascript: void(0)"> فرصت </a>
                                        </label>
                                    </div>
                                    </div>
                                </div> -->
                                    <div class="form-group">
                                        <div class="col-sm-offset-2 col-sm-10">
                                            <button type="button" @click="updateProfile"
                                                    class="btn btn-danger">{{ $t('done') }}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </div>
                        <!-- /.tab-pane -->
                        <div class="active tab-pane" id="remainderPerson">
                            <!-- The timeline -->
                            <button type="button" class="btn btn-danger btn-xs btn-pulus" data-toggle="modal"
                                    data-target="#notes">  {{ $t('Add note/attachment') }}+ </button>

                            <!-- Modal -->
                            <div id="notes" class="modal fade" role="dialog">
                                <div class="modal-dialog">

                                    <!-- Modal content-->
                                    <div class="modal-content">


                                        <form v-on:submit.prevent="getremainerAll()">

                                            <div class="modal-header">
                                                <button type="button" class="close"
                                                        data-dismiss="modal">&times;</button>
                                                <h4 class="modal-title">{{ $t('Notes and attachments') }}  </h4>
                                            </div>
                                            <div class="modal-body">
                                                <div class="form-group">
                                                    <label for="comment">{{ $t('Description') }} </label>
                                                    <textarea v-model="note.comment" class="form-control"
                                                              rows="2" id="comment" aria-describedby="fileHelpId"></textarea>
                                                </div>
                                                <!--                                                    <div class="form-group">-->
                                                <!--                                                        <label for="rate">{{ $t('Points / Degree of importance') }} </label>-->
                                                <!--                                                        <select v-model="note.rate" class="form-control" id="rate">-->
                                                <!--                                                            <option value="1">1</option>-->
                                                <!--                                                            <option value="2">2</option>-->
                                                <!--                                                            <option value="3">3</option>-->
                                                <!--                                                            <option value="4">4</option>-->
                                                <!--                                                            <option value="5">5</option>-->
                                                <!--                                                        </select>-->
                                                <!--                                                    </div>-->

                                                <div class="row">
                                                    <div class="col-xs-12 form-group">
                                                        <label class="control-label">{{ $t('Image') }} </label>
                                                        <div class="form-group">
                                                            <div class="input-group input-file" name="Fichier1">
                                                                <input type="text" class="form-control"
                                                                       :placeholder="placeholdernote" />
                                                                <input type="file" class="filestyle" ref="fileNote"
                                                                       @change="onFileChangeNote($event)" />
                                                                <span class="input-group-btn">
                                                                        <!--<button class="btn btn-default btn-choose" type="button">فایل</button>-->
                                                                    </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>




                                            </div>
                                            <div class="modal-footer">
                                                <button type="button" class="btn btn-default"
                                                        data-dismiss="modal">{{ $t('Close') }}</button>
                                                <button class="btn btn-primary" data-dismiss="modal"
                                                        @click="getremainerAll"> {{ $t('done') }}</button>
                                            </div>


                                        </form>

                                    </div>

                                </div>
                            </div>
                            <ul class="timeline timeline-inverse">
                                <!-- timeline time label -->



                                <!--<li class="time-label">-->
                                <!--<span class="">-->
                                <!--۱۲ اردیبهشت 1398-->
                                <!--</span>-->
                                <!--</li>-->
                                <!-- /.timeline-label -->
                                <!-- timeline item -->

                                <li v-for="(note, index) in remainerlist" :key="index">

                                    <!--<i class="fa fa-envelope bg-blue"></i>-->
                                    <i class="fa fa-user bg-aqua"></i>


                                    <div class="timeline-item">
                                            <span class="time"><i class="fa fa-clock-o"></i>
                                                {{ note.created_at | moment("jYYYY/jMM/jDD") }}
                                            </span>

                                        <h3 v-if="note.person" class="timeline-header">
                                            {{ note.person.name }} {{ note.person.family }}
                                        </h3>

                                        <div class="timeline-body">
                                            {{ note.comment }}
                                        </div>

                                        <!--                                            <div class="timeline-body">{{ $t('Score') }}:-->
                                        <!--                                                {{ note.rate }}-->
                                        <!--                                            </div>-->


                                        <div v-if="note.image" class="timeline-body">{{ $t('the attachment') }}
                                            <img class="img" :src="'/'+note.image">
                                            <a :href="'/'+note.image" v-if="note.image"> {{ $t('Download') }} </a>
                                        </div>
                                        <div class="timeline-footer">
                                            <a target="_blank" href="javascript: void(0)"
                                               class="btn btn-xs btn-danger"
                                               v-on:click="deleteEntry(note.id, index)">
                                                {{ $t('Delete') }}
                                            </a>

                                            <!-- <router-link :to="{path: '/payment/'+item.id, params: {id: item.id}}"
                                                class="btn btn-primary btn-xs">
                                                رسید درخواست
                                            </router-link> -->


                                        </div>
                                    </div>
                                </li>



















                                <!-- END timeline item -->
                                <!-- timeline item -->
                                <!--<li>-->
                                <!--<i class="fa fa-user bg-aqua"></i>-->

                                <!--<div class="timeline-item">-->
                                <!--<span class="time"><i class="fa fa-clock-o"></i> 5 دقیقه پیش</span>-->

                                <!--<h3 class="timeline-header no-border"><a href="javascript: void(0)">سارا</a> درخواست    خدمات {{$customerLable}} با موفقیت ثبت گردید </h3>-->
                                <!--</div>-->
                                <!--</li>-->
                                <!-- END timeline item -->
                                <!-- timeline item -->

                                <!-- END timeline item -->
                                <!-- timeline time label -->
                                <!--<li class="time-label">-->
                                <!--<span class="bg-green">-->
                                <!--۱۲ خرداد 1398-->
                                <!--</span>-->
                                <!--</li>-->
                                <!-- /.timeline-label -->
                                <!-- timeline item -->
                                <!--<li>-->
                                <!--<i class="fa fa-camera bg-purple"></i>-->

                                <!--<div class="timeline-item">-->
                                <!--<span class="time"><i class="fa fa-clock-o"></i> 2 روز پیش</span>-->

                                <!--<h3 class="timeline-header"><a href="javascript: void(0)">مینا</a> تصویر {{$customerLable}} بعد آرایش </h3>-->

                                <!--<div class="timeline-body">-->
                                <!--<img src="http://placehold.it/150x100" alt="..." class="margin">-->
                                <!--<img src="http://placehold.it/150x100" alt="..." class="margin">-->
                                <!--<img src="http://placehold.it/150x100" alt="..." class="margin">-->
                                <!--<img src="http://placehold.it/150x100" alt="..." class="margin">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</li>-->
                                <!-- END timeline item -->
                                <li>
                                    <!--<i class="fa fa-clock-o bg-gray"></i>-->
                                    <i class="fa fa-envelope bg-blue"></i>

                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- /.tab-content -->
                </CCard>

            </CCol>





            <CCol md="3">

                <button type="button" class="btn btn-warning btn-modal" data-toggle="modal"
                        data-target="#contact"><i class="fa fa-edit"></i></button>
                <CCard class="p-4 mt-2">


                    <!-- Modal -->
                    <div id="contact" class="modal fade" role="dialog">
                        <div class="modal-dialog">

                            <!-- Modal content-->
                            <div class="modal-content">
                                <form class="form-horizontal ">
                                    <div class="modal-header">
                                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                                        <h4 class="modal-title">{{ $t('Contacts')}}</h4>
                                    </div>
                                    <div class="modal-body">
                                        <div class="row mx">

                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('Name') }}</label>

                                                <div class="">
                                                    <input type="text" class="form-control "
                                                           v-model="contact.first_name" :placeholder="$t('Name')">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('surname') }}</label>

                                                <div class="">
                                                    <input type="text" class="form-control" v-model="contact.last_name"
                                                           :placeholder="$t('surname')">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('e-mail') }}</label>

                                                <div class="">
                                                    <input type="email" class="form-control" v-model="contact.email"
                                                           :placeholder="$t('e-mail')">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('Mobile') }}</label>

                                                <div class="">
                                                    <input type="text" class="form-control" v-model="contact.mobile"
                                                           :placeholder="$t('Mobile')">
                                                </div>
                                            </div>
                                            <div class="">
                                                <label class="control-label"> {{ $t('Image') }}</label>
                                                <div class="form-group">
                                                    <div class="input-group input-file" name="Fichier1">
                                                        <input type="text" class="form-control"
                                                               :placeholder="placeholder" />
                                                        <input type="file" class="filestyle" ref="file"
                                                               @change="onFileChange($event)" />
                                                        <span class="input-group-btn">
                                                            <button class="btn btn-default btn-choose"
                                                                    type="button"> {{ $t('File') }}</button>
                                                        </span>


                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('phone') }}</label>

                                                <div class="">
                                                    <input type="tel" class="form-control" v-model="contact.tell"
                                                           :placeholder="$t('phone')">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label">{{$t('Code')}}</label>

                                                <div class="">
                                                    <input type="text" class="form-control"
                                                           v-model="contact.national_code" :placeholder="$t('National Code')">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="mb-5 control-label" >{{ $t('Address') }}</label>

                                                <div class="">
                                                    <input type="text" class="form-control" v-model="contact.address"
                                                           :placeholder="$t('Address')">
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="mb-5 control-label"> {{ $t('Town') }}</label>

                                                <div class="">
                                                    <input type="text" class="form-control" v-model="contact.city"
                                                           :placeholder="$t('Town')">
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-default" data-dismiss="modal"> {{ $t('Close') }}</button>


                                        <button type="button" @click="updateContact" class="btn btn-danger"
                                                data-dismiss="modal"> {{ $t('done') }}</button>

                                    </div>
                                </form>
                            </div>

                        </div>
                    </div>
                    <!-- Modal -->
                    <div id="profile" class="modal fade" role="dialog">
                        <div class="modal-dialog">

                            <!-- Modal content-->
                            <div class="modal-content">
                                <!--<form class="form-horizontal ">-->
                                <!--<div class="modal-header">-->
                                <!--<button type="button" class="close" data-dismiss="modal">&times;</button>-->
                                <!--<h4 class="modal-title"> پرونده</h4>-->
                                <!--</div>-->
                                <!--<div class="modal-body">-->
                                <!--<div class="row mx">-->


                                <!--<div class="form-group col-xs-6 ">-->
                                <!--<label class="mb-5 control-label">معرف</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.regent"-->
                                <!--placeholder="معرف">-->
                                <!--</div>-->
                                <!--</div>-->


                                <!--<div class="form-group col-xs-6 ">-->
                                <!--<label class="mb-5 control-label">طریقه آشنایی</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.reagent_type"-->
                                <!--placeholder="طریقه آشنایی">-->
                                <!--</div>-->
                                <!--</div>-->



                                <!--<div class="form-group col-xs-6 ">-->
                                <!--<label class="mb-5 control-label">پیج تبلیغ شده</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.reagent_page"-->
                                <!--placeholder="پیج تبلیغ شده">-->
                                <!--</div>-->
                                <!--</div>-->


                                <!--<div class="form-group col-xs-6 ">-->
                                <!--<label class="mb-5 control-label">سایت تبلیغ شده</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.reagent_site"-->
                                <!--placeholder="سایت تبلیغ شده">-->
                                <!--</div>-->
                                <!--</div>-->

                                <!--</div>-->
                                <!--<hr>-->

                                <!--<div class="row mx" style="direction: rtl">-->


                                <!--<div class="form-group col-xs-6 ">-->
                                <!--<label class="mb-5 control-label">جنسیت</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control "-->
                                <!--v-model="profileInfo.gender" placeholder="جنسیت">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">رشته تحصیلی</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control "-->
                                <!--v-model="profileInfo.education_field" placeholder="رشته">-->
                                <!--</div>-->
                                <!--</div>-->



                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">تخصص</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control " v-model="profileInfo.major"-->
                                <!--placeholder="تحصلات و ...">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">فیلد کاری</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control "-->
                                <!--v-model="profileInfo.work_field" placeholder="شغل و ...">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">سن</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.age"-->
                                <!--placeholder="سن">-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">تولد</label>-->

                                <!--<div class="">-->


                                <!--<custom-time-picker v-model="profileInfo.birth" :clearable="true"-->
                                <!--placeholder="تاریخ تولد را انتخاب کنید"-->
                                <!--format="jYYYY/jMM/jDD">-->
                                <!--</custom-time-picker>-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group col-xs-12">-->
                                <!--<label class="mb-5 control-label">توضیحات</label>-->

                                <!--<div class="">-->
                                <!--<textarea class="form-control" v-model="profileInfo.visitor_note"-->
                                <!--placeholder="توضیحات"></textarea>-->
                                <!--</div>-->
                                <!--</div>-->


                                <!--</div>-->

                                <!--<hr>-->

                                <!--<div class="row mx">-->

                                <!--<div v-if="$businessType == 'Health'">-->


                                <!--<div class="row mx">-->

                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">قد</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.height"-->
                                <!--placeholder="قد">-->
                                <!--</div>-->
                                <!--</div>-->


                                <!--<div class="form-group col-xs-6">-->
                                <!--<label class="mb-5 control-label">وزن</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control" v-model="profileInfo.weight"-->
                                <!--placeholder="وزن">-->
                                <!--</div>-->
                                <!--</div>-->

                                <!--</div>-->


                                <!--<hr>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">سابقه بیماری</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline "><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.heart" value="1" >قلبی</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.respiratory" value="1">تنفسی</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Liver" value="1"> کبدی</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Kidney" value="1">کلیوی</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Diabetes" value="1">دیابت</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Seizure" value="1">تشنج</label>-->

                                <!--</div>-->
                                <!--</div>-->


                                <!--<hr>-->
                                <!--<div class="form-group">-->

                                <!--<label class="mb-5 control-label">سابقه تبخال</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.infectiousdisease" value="1">بیماری-->
                                <!--عفونی</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.tumor" value="1">تومور</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.asthma" value="1"> اسم</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.thyroid" value="1">تیروءید</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.hormonaldisorder" value="1">اختلال-->
                                <!--هرمونی</label>-->
                                <!--<br>-->

                                <!--<label class="mb-5 control-label">سایر</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control"-->
                                <!--v-model="profileInfo.otherHerpes" placeholder="سایر">-->

                                <!--</div>-->

                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->
                                <!--<div class="form-group">-->

                                <!--<label class="mb-5 control-label">سابقه مصرف دارو</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.asprin" value="1">آسپرین</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.deyper" value="1">دیپرمدامل</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.convulsion" value="1"> داروی ضد-->
                                <!--تشنج</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.arpharin" value="1">آرفارین</label>-->
                                <!--<label class="checkbox-inline"><input type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.heparin" value="1">هپارین</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.minoxide" value="1">ماینوکسید</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.hormonal" value="1">داروی-->
                                <!--هورمونی</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.rakuten" value="1">راکوتان</label>-->
                                <!--<label class="checkbox-inline"><input  type="checkbox" class="option-input checkbox"-->
                                <!--v-model="profileInfo.cream" value="1">کرم لایه بردار</label>-->

                                <!--<br>-->
                                <!--<label class="mb-5 control-label">سایر</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control"-->
                                <!--v-model="profileInfo.otherpharmacy" placeholder="سایر">-->

                                <!--</div>-->
                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->
                                <!--<div class="form-group">-->

                                <!--<label class="mb-5 control-label">اقدام به برنزه کردن در دوماه-->
                                <!--اخیر</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.boronz" name="boronz" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.boronz" name="boronz"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->

                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">سابقه هرگونه حساسیت-->
                                <!--,فصلی,دارویی,غذایی؟</label>-->

                                <!--<div class="">-->
                                <!--<textarea class="form-control" v-model="profileInfo.allergy"-->
                                <!--placeholder="توضیحات"></textarea>-->

                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->
                                <!--<div class="form-group">-->

                                <!--<label class="mb-5 control-label">سابقه جراحی</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.surgery" name="surgery" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.surgery" name="surgery"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">نوع جراحی</label>-->

                                <!--<div class="">-->
                                <!--<input type="text" class="form-control"-->
                                <!--v-model="profileInfo.typeSurgery" placeholder="جراحی">-->

                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">درحال حاضر باردارید</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.getpregnant" name="getpregnant"-->
                                <!--value="1">بله </label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.getpregnant" name="getpregnant"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">شیر دهی</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.milch" name="milch" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.milch" name="milch"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->

                                <!--<hr>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">سابقه تزریق بوتاکس</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Botox" name="Botox" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Botox" name="Botox"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">سابقه تزریق ژل</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.zhel" name="zhel" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.zhel" name="zhel" value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->
                                <!--<div class="form-group">-->
                                <!--<label class="mb-5 control-label">سابقه انجام لیزر</label>-->

                                <!--<div class="">-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Laser" name="Laser" value="1">بله-->
                                <!--</label>-->
                                <!--<label class="checkbox-inline"><input type="radio" class="option-input checkbox"-->
                                <!--v-model="profileInfo.Laser" name="Laser"-->
                                <!--value="0">خیر</label>-->

                                <!--</div>-->
                                <!--</div>-->






                                <!--</div>-->




                                <!--</div>-->

                                <!--</div>-->
                                <!--<div class="modal-footer">-->
                                <!--<button type="button" class="btn btn-default" data-dismiss="modal">بستن</button>-->

                                <!--<button type="button" @click="updateProfile" class="btn btn-success"-->
                                <!--data-dismiss="modal">ثبت</button>-->

                                <!--</div>-->
                                <!--</form>-->
                            </div>

                        </div>
                    </div>
                    <!-- Profile Image -->
                    <div class="box box-primary">

                        <div class="box-body box-profile">

<!--                            <img v-if="contact.image" class="profile-user-img img-responsive img-circle"-->
<!--                                 :src="`/`+contact.image" alt=" profile picture">-->
<!--                            <img v-else class="profile-user-img img-responsive img-circle"-->
<!--                                 src="/dist/img/user7-128x128.jpg" alt=" profile picture">-->
                            <h3 class="profile-username text-center">
                                {{contact.first_name}} {{contact.last_name}}
                            </h3>

                            <!-- <p class="text-muted text-center"> تولد: --/--/--</p> -->

                            <ul class="list-group list-group-unbordered">

                                <li class="list-group-item">
                                    <b> {{ $t('Mobile') }} </b> <a class="pull-left">
                                        <span
                                                style="color: #a01c7d;font-weight: bold;font-size: 16px">{{contact.mobile}}</span>
                                </a>
                                </li>
                                <li class="list-group-item">
                                    <b>{{ $t('phone') }}/{{$t('Mobile')}} </b> <a class="pull-left">
                                    {{contact.tell}}
                                </a>
                                </li>
                                <li class="list-group-item">
                                    <b> {{ $t('Score') }} </b> <a class="pull-left">
                                    <span class="badge label-info"> {{contact.score}} </span>

                                </a>
                                </li>

                                <li class="list-group-item" style="line-height: 28px">

                                    <div class="form-group" v-if="contactsPayments > contactsOrders" >
                                        <br>
                                        <span style="color: #222;">{{ $t('Extra customer credit') }}:</span>
                                        <span style="font-weight: bold">{{ spliceNumber(contactsPayments-contactsOrders) }} {{$curency}}</span>
                                    </div>

                                    <div class="form-group">
                                        <br>
                                        <span style="color: #8150e4;">{{ $t('Total customer orders') }} :</span>
                                        <span style="font-weight: bold">{{ spliceNumber(contactsOrders) }} {{$curency}}</span>
                                        <br>
                                        <span style="color: #009101;"> {{ $t('Total customer payments') }} :</span>
                                        <span style="font-weight: bold">{{ spliceNumber(contactsPayments) }} {{$curency}}</span>
                                        <br>
                                    </div>
                                    <div class="form-group" v-if="contactsPayments < contactsOrders" >
                                        <span style="color: #ff5444;"> {{ $t('Balance payable') }}:</span>
                                        <span style="font-weight: bold">{{ spliceNumber(contactsOrders-contactsPayments) }}  {{$curency}}</span>

                                    </div>
                                </li>
                            </ul>


<!--                            <router-link class="btn btn-success  btn-xs btn-block" :to="`/request/`+contact.user_id">-->
<!--                                <b> {{ $t('booking') }}-->
<!--                                    {{$business}}-->
<!--                                    ({{ $t('done') }} {{ $t('Order') }}) </b>-->
<!--                            </router-link>-->
<!--                            <router-link class="btn btn-info btn-xs btn-block" :to="{name:`contactPayIndex`}">-->
<!--                                <b>-->
<!--                                    {{ $t('Manage payments/credit enhancement') }}-->
<!--                                </b>-->
<!--                            </router-link>-->
                        </div>
                        <!-- /.box-body -->
                    </div>
                    <!-- /.box -->

                    <b-btn v-if="contact.type == 4"  class="mt-3"
                           data-toggle="modal"
                           data-target="#vendor-products">
                        محصولات تأمین کننده
                    </b-btn>

                  <b-btn class="mt-3" variant="success"
                         data-toggle="modal"
                         data-target="#sub-contacts">
                    سایر اطلاعات تماس
                  </b-btn>

                </CCard>

            </CCol>

        </CRow>




        <div id="vendor-products" class="modal fade" role="dialog">
            <div class="modal-dialog modal-lg">

                <!-- Modal content-->
                <div class="modal-content">


                    <form v-on:submit.prevent="updateVendorProducts()">

                        <div class="modal-header ">
                            <button type="button" class="close"
                                    data-dismiss="modal">&times;</button>
                            <h4 class="modal-title">محصولات تامین کننده  </h4>
                        </div>
                        <div class="modal-body">

                            <table class="table table-dark table-striped table-bordered table-sm">
                                <thead>
                                <tr>
                                    <th scope="col">
                                        <b-btn @click="addVendorProduct()" size="sm" variant="success">
                                            <i class="fa fa-plus"></i>
                                        </b-btn>
                                    </th>
                                    <th colspan="2">کالا</th>
                                    <th scope="col">قیمت</th>
                                    <th scope="col">موجودی</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(vendorProduct , vendorProductIndex) in vendorProducts" :key="vendorProductIndex">
                                    <th scope="row">{{vendorProductIndex+1}}</th>
                                    <td colspan="2" style="background-color: rgba(255,255,255,.6)" class="pt-0">
                                        <v-select
                                                v-model="vendorProduct.product_id" class="form-control-sm"
                                                :options="products" label="title" :reduce="product => product.id" value="id">
                                        </v-select>
                                    </td>
                                    <td :title="spliceNumber(vendorProduct.price)">
                                        <input class="form-control form-control-sm" v-model="vendorProduct.price"
                                               type="number" data-type="number">
                                    </td>
                                    <td>
                                        <input class="form-control form-control-sm" v-model="vendorProduct.initial_amount"
                                               type="number" data-type="number">
                                    </td>
                                    <td>
                                        <span @click="deleteVendorProduct(vendorProductIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                                    </td>
                                </tr>

                                </tbody>
                            </table>




                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-default"
                                    data-dismiss="modal">{{ $t('Close') }}</button>
                            <button class="btn btn-primary" data-dismiss="modal"
                                    @click="updateVendorProducts()">بروزرسانی محصولات و قیمت ها</button>
                        </div>


                    </form>

                </div>

            </div>
        </div>




      <div id="sub-contacts" class="modal fade" role="dialog">
        <div class="modal-dialog modal-lg">

          <!-- Modal content-->
          <div class="modal-content">


            <form v-on:submit.prevent="updateSubContacts()">

              <div class="modal-header ">
                <button type="button" class="close"
                        data-dismiss="modal">&times;</button>
                <h4 class="modal-title">  اطلاعات تماس  </h4>
              </div>
              <div class="modal-body">

                <table class="table table-dark table-striped table-bordered table-sm">
                  <thead>
                  <tr>
                    <th scope="col">
                      <b-btn @click="addSubContact()" size="sm" variant="success">
                        <i class="fa fa-plus"></i>
                      </b-btn>
                    </th>
                    <th scope="col">نام</th>
                    <th scope="col">نام خوانوادگی</th>
                    <th scope="col">موبایل</th>
                    <th scope="col">تلفن</th>
                    <th scope="col">ایمیل</th>
                    <th scope="col"><small>سمت</small></th>
                    <th scope="col"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(subContact , subContactIndex) in subContacts" :key="subContactIndex">
                    <th scope="row">{{subContactIndex+1}}</th>


                    <td>
                      <CInput
                          v-model="subContact.first_name"
                          label="نام"
                          placeholder=""
                      />
                    </td>

                    <td>
                      <CInput
                          v-model="subContact.last_name"
                          label=" نام خانوادگی"
                          placeholder=""
                      />
                    </td>
                    <td>
                      <CInput
                          v-model="subContact.mobile"
                          label="موبایل "
                          type="number"
                          placeholder=""

                      />
                    </td>
                    <td>
                      <CInput
                          v-model.number="subContact.tell"
                          label="تلفن/فکس "
                          placeholder=""

                      />
                    </td>

                    <td>
                      <CInput
                          v-model="subContact.email"
                          label="ایمیل"
                          type="email"
                          placeholder=""
                      />
                    </td>

                    <td>
                      <CInput
                          v-model="subContact.other_info"
                          label="سمت/یادداشت"
                          type="text"
                          placeholder=""
                      />
                    </td>


                    <td>
                                        <span @click="deleteSubContact(subContactIndex)">
                                             <i class="fa fa-times"></i>
                                        </span>
                    </td>
                  </tr>

                  </tbody>
                </table>




              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default"
                        data-dismiss="modal">{{ $t('Close') }}</button>
                <button class="btn btn-primary" data-dismiss="modal"
                        @click="updateSubContacts()">بروزرسانی اطلاعات تماس</button>
              </div>


            </form>

          </div>

        </div>
      </div>



    </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>


    import Multiselect from 'vue-multiselect'

    export default {
        name: 'Dashboard',
        components: {


            Multiselect,



        },
        data () {
            return {
                selected: 'Month',
                tableItems: [
                    {
                        avatar: { url: 'img/avatars/1.jpg', status: 'success' },
                        user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'USA', flag: 'cif-us' },
                        usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
                        activity: '10 sec ago'
                    },
                    {
                        avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
                        user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
                        country: { name: 'Brazil', flag: 'cif-br' },
                        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Visa', icon: 'cib-cc-visa' },
                        activity: '5 minutes ago'
                    },
                    {
                        avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
                        user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'India', flag: 'cif-in' },
                        usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Stripe', icon: 'cib-stripe' },
                        activity: '1 hour ago'
                    },
                    {
                        avatar: { url: 'img/avatars/4.jpg', status: '' },
                        user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'France', flag: 'cif-fr' },
                        usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'PayPal', icon: 'cib-paypal' },
                        activity: 'Last month'
                    },
                    {
                        avatar: { url: 'img/avatars/5.jpg', status: 'success' },
                        user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'Spain', flag: 'cif-es' },
                        usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
                        activity: 'Last week'
                    },
                    {
                        avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
                        user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
                        country: { name: 'Poland', flag: 'cif-pl' },
                        usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
                        payment: { name: 'Amex', icon: 'cib-cc-amex' },
                        activity: 'Last week'
                    }
                ],
                tableFields: [
                    { key: 'avatar', label: '', _classes: 'text-center' },
                    { key: 'user' },
                    { key: 'country', _classes: 'text-center' },
                    { key: 'usage' },
                    { key: 'payment', label: 'Payment method', _classes: 'text-center' },
                    { key: 'activity' },
                ],





                auth: {
                    headers: {
                        Authorization: 'bearer ' + localStorage.getItem('token')
                    }
                },
                loadMore: true,
                page: 1,
                pageSize: 10,
                voice: '',

                courseCategories:[],
                fileCategories:[],
                forumCategories:[],
                forums:[],


                issues:[],
                issueText: 0,
                newIssue: {
                    intro:'',
                    state:'0',
                    title:'',
                    text:'0',

                    voice:'',
                    file:'',
                    image:'',
                    video:'',

                    news:0,
                    course_id:null,
                    course_category_id:null,
                    forum_id:null,
                    forum_category_id:null,
                    fileLib_tags:null,
                    // issue_likes:null,
                    // userLike:null,

                    type:'ticket',
                    project_id:null,
                    board_id:2,
                    users:[],

                    priority:2,
                    due_date:null,
                    tags:[],

                },

                rules: [v => v.length <= 300 || 'تعداد حروف بیشتر از 300 کاراکتر است!'],

                showVoiceRecorder: false,
                showFileUploader: false,
                showImageUploader: false,
                showVideoUploader: false,

                src: null,
                srcPlay: null,

                issueAsCourse: false,
                issueAsForum: false,

                courseDisabled: false,
                forumDisabled: false,

                newComment:'',
                newReply:'',

                options:[],

                selectedTags: [],
                tags: [],
                isLoading: false,




                typeOptions: [
                    { value: 'ticket', text: 'پیگیری (Ticket)' , selected :true},
                    { value: 'bug', text: 'ایراد (Bug)' },
                    { value: 'task', text: 'فعالیت (Task)' },
                    { value: 'user-story', text: 'لیست (User Story)' },
                    { value: 'epic', text: 'نسخه/فیچر (Epic)' },
                    { value: 'lead', text: 'سرنخ/فرصت (Lead)' },
                    { value: 'meeting', text: 'ملاقات/جلسه/رویداد' },

                ],



                warningModal: false,


                search: {

                    title: '',
                    description: '',
                    type: '',
                    project_id: '',
                    section_id: '',
                    process_id: '',
                    step_id: '',
                    board_id: '',

                    created_at_from: '',
                    created_at_to: '',
                    due_date: '',
                    start_date: '',
                    done_date_from: '',
                    done_date_to: '',
                    close_date: '',

                    priority: '',
                    contact_id: '',
                    order_id: '',
                    person_id: '',
                    created_by: '',
                    updated_by: '',
                },


                contact_id: '',
                contacts: [],

                collapseFilter:false,
                collapseNewIssue:false,











                contact: {},
                profileInfo: {
                    heart: '',
                    respiratory: '',
                    Liver: '',
                    Kidney: '',
                    Diabetes: '',
                    Seizure: '',
                    infectiousdisease: '',
                    tumor: '',
                    asthma: '',
                    thyroid: '',
                    hormonaldisorder: '',
                    otherHerpes: '',
                    asprin: '',
                    deyper: '',
                    convulsion: '',
                    arpharin: '',
                    heparin: '',
                    minoxide: '',
                    hormonal: '',
                    rakuten: '',
                    cream: '',
                    otherpharmacy: '',
                    boronz: '',
                    allergy: '',
                    surgery: '',
                    typeSurgery: '',
                    getpregnant: '',
                    milch: '',
                    Botox: '',
                    zhel: '',
                    Laser: '',
                    weight: '',
                    height: '',

                    regent: '',
                    reagent_detail: '',
                    reagent_state: '',
                    reagent_page: '',
                    reagent_site: '',
                    reagent_type: '',
                    regent_id: '',

                    text: '',



                },
                favartieItems: {},
                item: {},
                remainerlist: [],
                note: {

                    comment: '',
                    rate: '0',
                    contact_id: '',
                    image: '',
                },
                favariteInput: {
                    number: "1",
                    title: ""

                },
                placeholder: "فایل را انتخاب کنید...",
                placeholdernote: "فایل را انتخاب کنید...",
                // image: '',
                Object: {},

                contactsOrders:'',
                contactsPayments: '',


                vendorProducts:[],

              subContacts:[],



            }
        },


        watch: {

            // newIssue: {
            //     intro(val){
            //         if (val.indexOf('word')!=-1)
            //             alert('111')
            //
            //     },
            //     deep: true
            // }



        },




        mounted() {
            this.getProcesses()
            this.getSteps()

            this.getCourseCategories()
            this.getFileCategories()
            this.getForumCategories()
            this.getForums()

            this.getOrders()
            this.getContacts()
            this.getVendorProducts()
            this.getSubContacts()
            this.getProducts()

            this.search.contact_id = this.$route.params.id;






            // old-profile
            let app = this;
            let id = app.$route.params.id;
            //          this.order = app.$route.params.order;
            app.itemId = id;
            axios
                .get('/api/contacts/' + id, app.auth)
                .then(function (resp) {
                    app.contact = resp.data.data;

                })
                .catch(function () {
                    app.$snotify.error(app.$t('No information available'));
                    app.$router.push({
                        path: '/contacts/'
                    });
                    //                  alert("بارگذاری دسته بندی ها امکان پذیر نیست");
                    //                    console.log('a: ' + auth)
                });
            app.favorite()
            app.getProfile()
            app.remainerAll()

            app.getContactsOrders()
            app.getContactsPayments()


        },



        methods: {
            color (value) {
                let $color
                if (value <= 25) {
                    $color = 'info'
                } else if (value > 25 && value <= 50) {
                    $color = 'success'
                } else if (value > 50 && value <= 75) {
                    $color = 'warning'
                } else if (value > 75 && value <= 100) {
                    $color = 'danger'
                }
                return $color
            },








            getIssues(){
                var app = this;

                axios.get('/api/intro/index' +
                    '?title='+app.search.title+
                    '&description='+app.search.description+
                    '&type='+app.search.type+
                    '&project_id='+app.search.project_id+
                    '&section_id='+app.search.section_id+

                    '&process_id='+app.search.process_id+
                    '&step_id='+app.search.step_id+
                    '&board_id='+app.search.board_id+

                    '&created_at_from='+app.search.created_at_from+
                    '&created_at='+app.search.created_at_to+
                    '&created_at_to='+app.search.due_date+
                    '&start_date='+app.search.start_date+
                    '&done_date_from='+app.search.done_date_from+
                    '&done_date_to='+app.search.done_date_to+
                    '&close_date='+app.search.close_date+

                    '&priority='+app.search.priority+
                    '&contact_id='+app.search.contact_id+
                    '&order_id='+app.search.order_id+
                    '&person_id='+app.search.person_id+
                    '&created_by='+app.search.created_by+
                    '&updated_by='+app.search.updated_by
                    , app.auth)
                    .then(function (response) {
                        app.issues = response.data.data
                        // console.log(response.data);
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getMoreIssues(){
                var app = this;



                if(app.loadMore == true){

                    axios.get('/api/intro/index' +
                        '?title='+app.search.title+
                        '&description='+app.search.description+
                        '&type='+app.search.type+
                        '&project_id='+app.search.project_id+
                        '&section_id='+app.search.section_id+

                        '&process_id='+app.search.process_id+
                        '&step_id='+app.search.step_id+
                        '&board_id='+app.search.board_id+

                        '&created_at_from='+app.search.created_at_from+
                        '&created_at='+app.search.created_at_to+
                        '&created_at_to='+app.search.due_date+
                        '&start_date='+app.search.start_date+
                        '&done_date_from='+app.search.done_date_from+
                        '&done_date_to='+app.search.done_date_to+
                        '&close_date='+app.search.close_date+

                        '&priority='+app.search.priority+
                        '&contact_id='+app.search.contact_id+
                        '&order_id='+app.search.order_id+
                        '&person_id='+app.search.person_id+
                        '&created_by='+app.search.created_by+
                        '&updated_by='+app.search.updated_by+
                        '&page='+app.page , app.auth)
                        .then(res => {
                            // app.issues.concat(res.data.data)
                            res.data.data.forEach(
                                (val)=>{ app.issues.push(val)});

                            app.page++

//                        if(res.data.data.lenght == null)
//                            app.endMore = true

                            // Stop scroll-loader
                            res.data.data.length < app.pageSize && (app.loadMore = false)
                        })
                        .catch(error => {
                            console.log(error);
                        })

                }


            },


            bottomVisible() {
                const scrollY = window.scrollY
                const visible = document.documentElement.clientHeight
                const pageHeight = document.documentElement.scrollHeight
                const bottomOfPage = visible + scrollY >= pageHeight
                return bottomOfPage || pageHeight < visible
            },

            // onFileChangeImage(e) {
            //     this.newIssue.image = this.$refs.file.files[0];
            //     this.placeholder = this.$refs.file.files[0].name+'333'
            //     console.log(this.newIssue ,"test Issue image")
            // },
            pluck(array, key) {
                return array.map(function (obj) {
                    return obj[key];
                });
            },
            createIssue(){
                var app = this;

                if(app.newIssue.fileLib_tags){
                    if(app.newIssue.fileLib_tags.length !==0){
                        app.newIssue.fileLib_tags = app.pluck(app.newIssue.fileLib_tags,"title")
                    }
                }


                if (app.newIssue.title.length == 0)
                    if(app.src == null
                        && app.newIssue.image == ''
                        && app.newIssue.video == ''
                        && app.newIssue.file == ''){
                        app.$snotify.error('ورودی های پست (Issue) خالی است')
                        return false}
                    else
                        app.newIssue.intro = '-'



                if (app.newIssue.title.length > 100 || app.newIssue.intro.length > 300){
                    app.$snotify.error('تعداد حروف بیشتر از  کاراکتر مجاز است! متن رو کوتاه تر نمایید. ');
                }else {

                    var newItem = app.newIssue;
                    let formData = new FormData();
                    for (const key in newItem) {
                        if (newItem.hasOwnProperty(key)) {
                            const element = newItem[key];
                            formData.append(key, element)
                            console.log(key, element);
                        }
                    }

                    if(app.src != null)
                        formData.append("voice",app.src, "filename.wav");


                    axios.post(`/api/intro/store`,  formData , app.auth)
                        .then(function (resp) {
                            console.log(resp,"IssueCreate")
                            // app.items.push(app.timing);
                            app.$snotify.success('پست (Issue) با موفقیت ثبت شد');
                            app.newIssue.title = ''
                            app.newIssue.intro = ''

                            app.newIssue.voice = ''
                            app.newIssue.file = ''
                            app.newIssue.image = ''
                            app.newIssue.video = ''
                            app.newIssue.news = 0
                            app.newIssue.course_id = null
                            app.newIssue.course_category_id = null
                            app.newIssue.forum_id = null
                            app.newIssue.forum_category_id = null
                            app.newIssue.fileLib_tags = null
                            app.src = null

                            app.getIssues()
                        })
                        .catch(
                            e => {
                                console.log(e.responsere);
                                console.log(e,"IssueCreate");
                                app.$snotify.error('امکان ثبت پست (Issue) وجود ندارد');
                            }
                        );

                }


            },

            //            openChat() {
            //                if (document.getElementById("box-chat").style.height == "400px") {
            //                    document.getElementById("box-chat").style.height = "60px"
            //                    document.getElementById("div-message-chat").style.display = "none"
            //                } else {
            //                    document.getElementById("box-chat").style.height = "400px"
            //                    document.getElementById("div-message-chat").style.display = "block"
            //                }
            //
            //
            //            },

            showIssueText(text, index ){

                this.issues[index].intro = text

            },

            onResult (data) {
//                console.log('The blob data:', data);
//                console.log('Downloadable audio', window.URL.createObjectURL(data));
                this.srcPlay =  window.URL.createObjectURL(data)
                this.src =  data

            },

            headerStyles(issue){
                if (issue.type == 1)
                    return '2px solid #a01c7d'
                else if (issue.type == 'ticket')
                    return '2px solid #263238'
                else if (issue.type == 'bug')
                    return '2px solid #ff2c00'
                else if (issue.type == 'task')
                    return '2px solid #00e853'
                else if (issue.type == 'user-story')
                    return '2px solid #0097a7'
                else if (issue.type == 'epic')
                    return '2px solid #0288ff'
                else if (issue.type == 'lead')
                    return '2px solid #950057'
                else if (issue.type == 'meeting')
                    return '2px solid #8e24aa'
                else if (issue.type == 'event')
                    return '2px solid #eeb600'
                else
                    return '2px solid #999999'
            },


            boardColor(boardID){
                if (boardID == 1)
                    return '#ee6600'
                else if (boardID == 2)
                    return '#ffd600'
                else if (boardID == 3)
                    return '#aeb130'
                else if (boardID == 4)
                    return '#64dd17'
                else if (boardID == 5)
                    return '#0097a7'
                else if (boardID == 6)
                    return '#00bfa5'
                else
                    return ''
            },

            typeBadgeStyles(issue){
                if (issue.type == 1)
                    return '#a01c7d'
                else if (issue.type == 'ticket')
                    return '#263238'
                else if (issue.type == 'bug')
                    return '#ff2c00'
                else if (issue.type == 'task')
                    return '#00e853'
                else if (issue.type == 'user-story')
                    return '#0097a7'
                else if (issue.type == 'epic')
                    return '#0288ff'
                else if (issue.type == 'lead')
                    return '#950057'
                else if (issue.type == 'meeting')
                    return '#8e24aa'
                else if (issue.type == 'event')
                    return '#eeb600'
                else
                    return '#999999'
            },

            getCourseCategories(){
                var app = this;
                axios.get('/api/admin/list/5', app.auth)
                    .then(function (response) {
                        app.courseCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getFileCategories(){
                var app = this;
                axios.get('/api/file/tagSearch/', app.auth)
                    .then(function (response) {
                        app.fileCategories = response.data.data.tags.data

                        console.log(response.data.data.tags.data)


                        for (const key in app.fileCategories) {
                            if (app.fileCategories.hasOwnProperty(key)) {
                                const element = app.fileCategories[key];

                                app.options.push({
                                    title: '#'+element.title,
                                    id: element.id
                                })
                                // this.details[0].
                            }
                        }
                        console.log(app.options)


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForumCategories(){
                var app = this;
                axios.get('/api/admin/list/2', app.auth)
                    .then(function (response) {
                        app.forumCategories = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getForums(){
                var app = this;
                axios.get('/api/forum/best', app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            updateForums(event){
                var categoryID = event;
                var app = this;
                axios.get('/api/forum/list?cat_id='+categoryID, app.auth)
                    .then(function (response) {
                        app.forums = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            likeIssue(issue){
                var app = this;
                axios.get('/api/issue/like/'+issue.id, app.auth)
                    .then(function (response) {

                        console.log(app.issues.find(x => x.id == issue.id).user_like)

                        if (app.issues.find(x => x.id == issue.id).user_like.length == 0) {
                            app.$snotify.success('پسند شما برای این پست (Issue) ثبت شد');
                            $("#like-far-"+issue.id).attr("data-prefix","fas");
                            $("#like-fas-"+issue.id).attr("data-prefix","fas");
                            // $("#like-far-"+issue.id).removeClass("fas").addClass("far");
                            app.issues.find(x => x.id == issue.id).like ++
                            app.issues.find(x => x.id == issue.id).user_like.push({
                                types_id: 1,
                                users_id: 0,
                                targets_id: issue.id})
                        }
                        else{
                            app.$snotify.info('پسند شما برای این پست (Issue) لغو شد');
                            $("#like-fas-"+issue.id).attr("data-prefix","far");
                            $("#like-far-"+issue.id).attr("data-prefix","far");
                            // $("#like-fas-"+post.id).removeClass("far").addClass("fas");
                            app.issues.find(x => x.id == issue.id).like --
                            app.issues.find(x => x.id == issue.id).user_like = []
                        }


                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getUserLikes(issue){
                var app = this;
                axios.get('/api/intro/likes/'+issue.id, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issue.id).issue_likes = response.data

                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            sendComment(issueId){
                var app = this;
                var newItem = {
                    parent_id: 0,
                    issue_id: issueId,
                    comment: document.getElementById('newComment-'+issueId).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('نظر با موفقیت ثبت شد');
                        document.getElementById('newComment-'+issueId).value = ''
                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت نظر وجود ندارد');
                        }
                    );

            },


            showReplyForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).show();
            },

            sendReply(issueId, commentID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issu_id: postId,
                    comment: document.getElementById('reply-'+issueId+'-'+commentID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+commentID).hide();
                        document.getElementById('reply-'+issueId+'-'+commentID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },


            sendReplyOfReply(issueId, commentID, replyID){
                var app = this;
                var newItem = {
                    parent_id: commentID,
                    issue_id: issueId,
                    comment: document.getElementById('reply-'+issueId+'-'+replyID).value,
                }

                axios.post(`/api/intro/commentStore`,  newItem , app.auth)
                    .then(function (resp) {
                        console.log(resp,"IssueCreate")
                        app.newComment = ''
                        app.updateIssueComments(issueId)
                        app.$snotify.success('پاسخ با موفقیت ثبت شد');
                        $('#reply-form-'+issueId+'-'+replyID).hide();
                        document.getElementById('reply-'+issueId+'-'+replyID).value = ''


                    })
                    .catch(
                        e => {
                            console.log(e.responsere);
                            app.$snotify.error('امکان ثبت پاسخ وجود ندارد');
                        }
                    );

            },

            hideForm(issueId, commentID){
                $('#reply-form-'+issueId+'-'+commentID).hide();
            },

            updateIssueComments(issueId){

                var app = this;
                axios.get('/api/intro/getComments/'+issueId+'/'+null, app.auth)
                    .then(function (response) {
                        app.issues.find(x => x.id == issueId).comments = response.data.data.data

                        console.log(app.issues.find(x => x.id == issueId).comments)
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });

            },

            getMoreComments(issueId){

                var app = this;
                if (!app.issues.find(x => x.id == issueId).commentPage)
                    app.issues.find(x => x.id == issueId).commentPage =2

                axios.get('/api/intro/getComments/'+issueId+'/'+null+'?page='+app.issues.find(x => x.id == issueId).commentPage, app.auth)
                    .then(res => {
                        res.data.data.data.forEach(
                            (val)=>{ app.issues.find(x => x.id == issueId).comments.push(val)});

                        if (res.data.data.data.length != 0)
                            app.issues.find(x => x.id == issueId).commentPage = res.data.data.current_page+1


                    })
                    .catch(error => {
                        console.log(error);
                    })



            },

            customLabel(option) {
                //   console.log(option.title)

                //   this.item.tags.push(option)
                return `${option.title}`

            },

            addTag (newTag) {
                // const tag = {
                //     name: newTag,
                //     code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
                // }
                // this.options.push(tag)
                // this.value.push(tag)

                this.options.push({
                    title: '#'+newTag,
                    id: 0
                })
            },




            ajaxFindTag(query){

            },


            limitText (count) {
                return `and ${count} other tags`
            },
            asyncFind (query) {
                this.isLoading = true
                this.ajaxFindTag(query).then(response => {
                    this.tags = response
                    this.isLoading = false
                })
            },
            clearAll () {
                this.selectedTags = []
            },


            getProcesses(){
                var app = this;
                axios.get('/api/intro/processes', app.auth)
                    .then(function (response) {
                        app.processes = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },

            getSteps(processID = null){
                var app = this;
                axios.get('/api/intro/steps/'+processID ,  app.auth)
                    .then(function (response) {
                        app.steps = response.data.data.data
                    })
                    .catch(function (e) {
                        console.log(e.response);
                    });
            },




            getOrders(){

                axios.get('/api/orders', this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.orders = response.data.data;
                        console.log(response.data.data)
                        // this.pagnationDate = response.data
                        // console.log(this.pagnationDate)
                        // this.loader = false
                    })
                    .catch(error => {
                        // this.loader = false
                        console.log(error);
                    })
            },

            getContacts(){

                axios.get('/api/contacts', this.auth)
                    .then(response => {
                        // this.current_page = response.data.current_page
                        this.contacts = response.data.data;
                        console.log(response.data.data)
                        // this.pagnationDate = response.data
                        // console.log(this.pagnationDate)
                        // this.loader = false

                        this.makeContactOptions()

                    })
                    .catch(error => {
                        // this.loader = false
                        console.log(error);
                    })
            },


            makeContactOptions(){
                var app = this;

                for (const key in app.contacts) {
                    if (app.contacts.hasOwnProperty(key)) {
                        const element = app.contacts[key];

                        app.contactOptions.push({
                            value: element.id,
                            text: element.first_name+' '+element.last_name
                        })
                        // this.details[0].
                    }
                }
                console.log(app.contacts)
                console.log(app.contactOptions)


            },






            addOrder(issueId ,orderId){

                var app = this;

                var params= {
                    order_id: orderId,
                    // state: state,
                }

                axios.post(`/api/issue/addOrder/`+issueId,  params , app.auth)
                    .then(function (resp) {
                        console.log(resp,"")
                        // app.items.push(app.timing);
                        app.$snotify.success(' با موفقیت ثبت شد');

                        app.getStepsWithIssues()
                    })
                    .catch(
                        e => {
                            console.log(e);
                            app.$snotify.error('امکان ثبت وجود ندارد');
                        }
                    );


            },




            changeContact(issueId ,contactId){

                var app = this;

                var params= {
                    contact_id: contactId,
                    // state: state,
                }

                axios.post(`/api/issue/changeContact/`+issueId,  params , app.auth)
                    .then(function (resp) {
                        console.log(resp,"")
                        // app.items.push(app.timing);
                        app.$snotify.success(' با موفقیت ثبت شد');

                        app.getStepsWithIssues()
                    })
                    .catch(
                        e => {
                            console.log(e);
                            app.$snotify.error('امکان ثبت وجود ندارد');
                        }
                    );


            },



            setContactId(){

                // console.log(event)

                // this.newPost.contact_id = event.value
                this.newPost.contact_id = this.contact_id

                console.log(this.newPost.contact_id)
            },








            getIssuesByType(type){

                this.search.type = type
                this.getIssues()

             },












            deletfavarit(id, index) {
                if (confirm(this.$t('Are you sure you want to delete the item?'))) {
                    var app = this;
                    axios.delete(`/api/contact/${app.$route.params.id}/favorite/` + id, app.auth)
                        .then(function (resp) {
                            app.favartieItems.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert(app.$t('Cannot delete item'));
                        });
                }
            },
            onFileChangeNote(e) {

                //    console.log(e.target.files[0])
                this.note.image = this.$refs.fileNote.files[0];
                this.placeholdernote = this.$refs.fileNote.files[0].name
                console.log(this.note.image, "note ch 144")

            },
            onFileChange(e) {

                //    console.log(e.target.files[0])
                this.contact.image = this.$refs.file.files[0];
                this.placeholder = this.$refs.file.files[0].name
                console.log(this.contact.image, "144")

            },
            deleteEntry(id, index) {
                if (confirm(this.$t('Are you sure you want to delete the item?'))) {
                    var app = this;
                    axios.delete(`/api/contact/${app.$route.params.id}/reviews/` + id, app.auth)
                        .then(function (resp) {
                            app.remainerlist.splice(index, 1);
                        })
                        .catch(function (resp) {
                            alert(this.$t('Cannot delete item'));
                        });
                }
            },
            getremainerAll() {
                //                let app = this
                //                app.note.contact_id=app.$route.params.id
                //                axios
                //                    .post(`/api/contact/${app.$route.params.id}/reviews`,app.note, app.auth)
                //                    .then(function (resp) {
                //                        app.remainerlist = resp.data.data;
                //                     app.remainerAll()
                //                        console.log(resp.data.data, "remainerlist")
                //                    })
                //                    .catch(function () {
                //                        app.$snotify.error('اطلاعات  در دسترس نیست');
                //                        // app.$router.push({
                //                        //     path: '/contacts/'
                //                        // });
                //                        //                  alert("بارگذاری دسته بندی ها امکان پذیر نیست");
                //                        //                    console.log('a: ' + auth)
                //                    });



                var app = this;
                var newItem = app.note;

                if (app.note.comment == ''){
                    app.$snotify.warning('متنی برای پیوست وارد کنید');
                    return false

                }

                app.note.contact_id = app.$route.params.id

                console.log(app.note, "note12312")

                app.loader = true
                let formData = new FormData();
                for (const key in newItem) {
                    if (newItem.hasOwnProperty(key)) {
                        const element = newItem[key];
                        formData.append(key, element)
                        console.log(key, element);
                    }
                }
                console.log(formData, "4444")

                axios
                    .post(`/api/contact/${app.$route.params.id}/reviews`, formData, app.auth)
                    //                axios.post('/api/services', formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));

                        app.remainerAll()

                        app.loader = false
                        console.log(resp);

                    })
                    .catch(function (e) {
                        app.loader = false
                        app.$snotify.warning('خطا در ثبت پیوست');
                        // app.errors.push(e.response.data.messages_fa);
                        // app.$snotify.warning(e.response.data.message);
                        console.log(e.response.data);


                        for (let value of e.response.data.messages_fa) {
                            //                        for (let error of Object.entries(value[1])) {
                            //                            console.log(app.object.entries(app.errors[0]));

                            app.$snotify.warning(value, {
                                timeout: 7000,
                                //                                    showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true
                            });

                            //                        }
                        }

                    });








            },
            remainerAll() {
                let app = this
                axios
                    .get(`/api/contact/${app.$route.params.id}/reviews`, app.auth)
                    .then(function (resp) {
                        app.remainerlist = resp.data.data;

                        console.log(resp.data.data, "remainerlist")
                    })
                    .catch(function () {
                        app.$snotify.error(app.$t('No information available'));
                        // app.$router.push({
                        //     path: '/contacts/'
                        // });
                        //                  alert("بارگذاری دسته بندی ها امکان پذیر نیست");
                        //                    console.log('a: ' + auth)
                    });

            },
            stateorder(index) {
                switch (index) {

                    case '0':
                        return  this.$t('It was Tibet')
                        break;
                    case '1':
                        return  this.$t('canceled')
                        break;
                    case '2':
                        return  this.$t('Paid')
                        break;
                    case '3':
                        return  this.$t('Done')
                        break;
                    default:
                        break;
                }
            },
            colorLabel(index) {

                var str = ((index + 1) / 4)
                var res = str.toString().split(".");

                switch (res[1]) {
                    case '0':
                        return "label-warning "
                        break;
                    case '25':
                        return "label-info"
                        break;
                    case '5':
                        return 'label-danger'
                        break;
                    case '05':
                        return 'label-danger'
                        break;
                    case '75':
                        return "label-warning "
                        break;
                    default:
                        return "label-warning "
                        break;
                }
            },
            stateColor(index) {
                switch (index) {

                    case '0':
                        return "label-info"
                        break;
                    case '1':
                        return 'label-danger'
                        break;
                    case '2':
                        return 'label-success'
                        break;
                    case '3':
                        return "label-gray "
                        break;
                    default:
                        break;
                }
            },
            request(id) {

                this.$router.push({
                    path: '/request/' + id,
                    params: {
                        id: id
                    }
                });

            },
            updateContact() {

                let app = this;
                let formData = new FormData();
                formData.append("_method", "PATCH")
                //  formData.append(key, element)
                for (const key in app.contact) {
                    if (app.contact.hasOwnProperty(key)) {
                        const element = app.contact[key];
                        if (element !== null)
                            formData.append(key, element)
                        // console.log(key, element);
                    }
                }
                axios
                    .post(`/api/contacts/${app.$route.params.id}`, formData, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));
                        // console.log(resp)
                        // app.$router.replace('/contacts');
                    })

                    .catch(function (e) {
                        // console.log(e.response);
                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }

                    });

            },
            updateProfile() {
                let app = this;
                // console.log(app.profileInfo)

                axios
                    .post(`/api/contact/${app.$route.params.id}/profile`, app.profileInfo, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));
                        console.log(resp)
                        // app.$router.replace('/contacts');
                    })

                    .catch(function (e) {
                        // console.log(e.response);
                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }

                    });
            },
            getProfile() {
                let app = this;
                // console.log(app.profileInfo)

                axios
                    .get(`/api/contact/${app.$route.params.id}/profile`, app.auth)
                    .then(function (resp) {
                        // app.$snotify.success(app.$t('Item saved successfully'));
                        app.profileInfo = resp.data.data
                        // console.log(resp, "mehdimehdi")
                        // app.$router.replace('/contacts');
                    })

                    .catch(function (e) {
                        // console.log(e.response);
                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }

                    });
            },
            updateFavarite() {
                let app = this;
                console.log(app.profileInfo)
                axios
                    .post(`/api/contact/${app.$route.params.id}/favorite`, app.favariteInput, app.auth)
                    .then(function (resp) {
                        app.$snotify.success(app.$t('Item saved successfully'));
                        console.log(resp)
                        app.favorite()
                        // app.$router.replace('/contacts');
                    })

                    .catch(function (e) {
                        // console.log(e.response);
                        for (let value of e.response.data.messages_fa) {
                            app.$snotify.warning(value, {
                                timeout: 7000,
                                closeOnClick: true,
                                pauseOnHover: true
                            });
                        }

                    });
            },
            print() {
                var printContents = document.getElementById('printDiv').innerHTML;
                var originalContents = document.body.innerHTML;
                document.body.innerHTML = printContents;
                window.print();
                document.body.innerHTML = originalContents;
            },
            favorite() {
                let app = this
                axios
                    .get(`/api/contact/${app.$route.params.id}/favorite`, app.auth)
                    .then(function (resp) {
                        app.favartieItems = resp.data.data;


                        console.log(resp.data.data, "5465131845")
                        // console.log(app.contact)
                    })
                    .catch(function (e) {
                        console.log(e.response)
                        // this.$snotify.error('اطلاعات  در دسترس نیست');
                        // app.$router.push({
                        //     path: '/sss'
                        // });
                    });
            },
            spliceNumber(number) {
                //  <input class="form-control" id="id_step2-number_2" name="step2-number_2" type="text" data-type="number">

                // $("input[data-type='number']").keyup(function (event) {
                //     var $this = $(this);
                //     var num2 = $this.val().replace(/,/gi, "").split(/(?=(?:\d{3})+$)/).join(",");
                //     $this.val(num2);
                // });
                if (number != null) {
                    return number.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                }
            },
            getContactsOrders() {

                let app = this;

                axios
                    .get('/api/contact/orders/' + app.$route.params.id, app.auth)
                    .then(function (resp) {
                        app.contactsOrders = resp.data;

                    })
                    .catch(function () {
                        app.$snotify.error(app.$t('No information available'));
                        app.$router.push({
                            path: '/contacts/'
                        });
                    });
            },
            getContactsPayments() {

                let app = this;
                axios
                    .get('/api/contact/payments/' + app.$route.params.id, app.auth)
                    .then(function (resp) {
                        app.contactsPayments = resp.data;

                    })
                    .catch(function () {
                        app.$snotify.error(app.$t('No information available'));
                        app.$router.push({
                            path: '/contacts/'
                        });
                    });
            },



            getProducts(){

                axios.get('/api/productslist', this.auth)
                    .then(response => {
                        console.log(response.data);

                        this.products = response.data.data;

                        this.products.forEach(function (element) {
                            element.number = "1";
                        });
                    })
                    .catch(error => {
                        console.log(error);
                        this.errored = true
                    })
                    .finally(() => this.loading = false);

            },

            addVendorProduct(){

                this.vendorProducts.push({
                    products_id: '',
                    price: 0,
                    initial_amount: 1,
                    note:'',
                    state:1,

                });

            },

            deleteVendorProduct(key){

                this.vendorProducts.splice(key,key);


            },

            getVendorProducts(){

                let app = this;
                axios.get('/api/vendor/products/'+ app.$route.params.id, app.auth)
                    .then(response => {
                        console.log('getVendorProducts',response.data)
                        app.vendorProducts = response.data.data;
                    })
                    .catch(error => {
                        console.log(error);
                    })

            },

            updateVendorProducts(){

                let app = this;

                let data =
                {
                    vendorProducts: app.vendorProducts
                }
                axios.post('/api/vendor/products/'+ app.$route.params.id, data , app.auth)
                    .then(response => {
                        app.$snotify.success(app.$t('Item saved successfully'));

                        app.getVendorProducts()
                    })
                    .catch(error => {
                        console.log(error);
                        app.$snotify.error('خطا در بروزرسانی مجصولات تولید کننده');

                    })

            },










          addSubContact(){

            this.subContacts.push({
              id: 0,
              first_name: '',
              last_name: '',
              mobile: '',
              tell: '',
              email: '',
              other_info:'',
              // state:1,

            });

          },

          deleteSubContact(key){

            this.subContacts.splice(key,key);


          },

          getSubContacts(){

            let app = this;
            axios.get('/api/subContact/contacts/'+ app.$route.params.id, app.auth)
                .then(response => {
                  console.log('getSubContacts',response.data)
                  app.subContacts = response.data.data;
                })
                .catch(error => {
                  console.log(error);
                })

          },

          updateSubContacts(){

            let app = this;

            let data =
                {
                  subContacts: app.subContacts
                }
            axios.post('/api/subContact/contacts/'+ app.$route.params.id, data , app.auth)
                .then(response => {
                  app.$snotify.success(app.$t('Item saved successfully'));

                  app.getSubContacts()
                })
                .catch(error => {
                  console.log(error);
                  app.$snotify.error('خطا در بروزرسانی ');

                })

          },







        }
    }
</script>











<style scoped>


    tr{
        box-shadow: 0px 4px 4px rgba(0,0,0,.15);

    }



</style>
